// GENERATED by `npm run gen:icons --prefix portal` from
// src/indigo-components/src/components/Icons/svg/{mono,color}/*.svg.
// Do not edit: change the SVG and re-run. See scripts/gen-icons.mjs.
import type { ReactElement } from "react";

export interface IconDefinition {
  /** The glyph, as the children of the `<svg>` `<Icon>` renders. */
  path: ReactElement;

  /** The grid the glyph is drawn on. `<Icon>` scales from it. */
  viewBox: { width: number; height: number };

  /**
   * What the icon renders at when the caller passes no size. Emitted only when
   * it differs from the viewBox, i.e. when the source SVG's root width/height
   * disagree with its grid.
   */
  defaultSize?: { width: number; height: number };
}

/**
 * Glyphs whose paint is driven by the `fill` / `stroke` props, through
 * `--icon-fill` / `--icon-stroke`. Source: `Icons/svg/mono/`.
 */
const MONO_ICONS = {
  "active-cases-tab": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.678 8.333a.833.833 0 0 0 .807-1.04 5.84 5.84 0 0 0-1.527-2.68l-2.905-2.905A5.8 5.8 0 0 0 7.928 0H4.166A4.17 4.17 0 0 0 0 4.167v11.666A4.17 4.17 0 0 0 4.167 20h2.5a.834.834 0 0 0 0-1.667h-2.5a2.503 2.503 0 0 1-2.5-2.5V4.167c0-1.379 1.121-2.5 2.5-2.5h3.762q.204 0 .404.019v4.147c0 1.379 1.122 2.5 2.5 2.5zM10 5.833V2.216q.476.272.875.672l2.904 2.904c.262.261.486.556.67.875h-3.616A.835.835 0 0 1 10 5.833M19.268 9.9c-.945-.945-2.591-.945-3.536 0l-5.589 5.59a3.31 3.31 0 0 0-.976 2.357v1.322c0 .46.373.833.833.833h1.322c.89 0 1.727-.348 2.356-.977l5.59-5.589c.472-.473.732-1.1.732-1.768 0-.669-.26-1.296-.732-1.768m-1.179 2.357-5.59 5.589a1.65 1.65 0 0 1-1.178.488h-.489v-.488c0-.445.174-.863.489-1.178l5.59-5.59a.853.853 0 0 1 1.178 0 .83.83 0 0 1 .244.59.83.83 0 0 1-.244.589" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "add-location": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M4.55 16.555c.675.667 1.562 1 2.448 1s1.772-.333 2.448-1l2.502-2.475A7.07 7.07 0 0 0 14 9.076a7.07 7.07 0 0 0-2.052-5.004A6.92 6.92 0 0 0 6.998 2a6.92 6.92 0 0 0-4.952 2.072c-2.73 2.759-2.73 7.248.008 10.015zM3.46 5.503a4.94 4.94 0 0 1 3.538-1.48 4.94 4.94 0 0 1 3.536 1.48 5.05 5.05 0 0 1 1.465 3.574c0 1.35-.52 2.62-1.457 3.567L8.047 15.11c-.578.57-1.52.57-2.098 0L3.46 12.652c-1.95-1.971-1.95-5.179 0-7.15m.537 3.564c0-1.675 1.343-3.033 3-3.033S10 7.392 10 9.067 8.655 12.1 6.998 12.1c-1.658 0-3.001-1.358-3.001-3.033M16.5 12a.7.7 0 0 1 .7.7v2.1h2.1a.7.7 0 0 1 0 1.4h-2.1v2.1a.7.7 0 0 1-1.4 0v-2.1h-2.1a.7.7 0 0 1 0-1.4h2.1v-2.1a.7.7 0 0 1 .7-.7" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "add-physician": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M19.167 9.167H17.5V7.5a.833.833 0 1 0-1.667 0v1.666h-1.666a.833.833 0 0 0 0 1.667h1.666V12.5a.833.833 0 1 0 1.667 0v-1.667h1.667a.833.833 0 1 0 0-1.667M7.5 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-8.333a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666M7.5 11.667a7.51 7.51 0 0 0-7.5 7.5.833.833 0 0 0 1.667 0 5.833 5.833 0 0 1 11.666 0 .833.833 0 0 0 1.667 0 7.51 7.51 0 0 0-7.5-7.5" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  add: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14.667A6.666 6.666 0 1 1 14.667 8 6.674 6.674 0 0 1 8 14.667M11.333 8a.667.667 0 0 1-.666.667h-2v2a.667.667 0 0 1-1.334 0v-2h-2a.667.667 0 0 1 0-1.334h2v-2a.667.667 0 0 1 1.334 0v2h2a.667.667 0 0 1 .666.667" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "align-center": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round">
        <path d="M2 3.5h12m-10 3h8m-10 3h12m-10 3h8" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "align-justify": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round">
        <path d="M2 3.5h12m-12 3h12m-12 3h12m-12 3h12" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "align-left": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round">
        <path d="M2 3.5h12m-12 3h8m-8 3h12m-12 3h8" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "align-right": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round">
        <path d="M2 3.5h12m-8 3h8m-12 3h12m-8 3h8" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "all-appointments-tab-icon": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M15.833 1.667H15V.833a.833.833 0 1 0-1.667 0v.834H6.667V.833A.833.833 0 0 0 5 .833v.834h-.833A4.17 4.17 0 0 0 0 5.833v10A4.17 4.17 0 0 0 4.167 20h11.666A4.17 4.17 0 0 0 20 15.833v-10a4.17 4.17 0 0 0-4.167-4.166M1.667 5.833a2.5 2.5 0 0 1 2.5-2.5h11.666a2.5 2.5 0 0 1 2.5 2.5v.834H1.667zm14.166 12.5H4.167a2.5 2.5 0 0 1-2.5-2.5v-7.5h16.666v7.5a2.5 2.5 0 0 1-2.5 2.5" />
        <path d="M10 13.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M5.832 13.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M14.168 13.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  "appointments-tab": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M6.667 10H5c-.92 0-1.667.748-1.667 1.667v1.666C3.333 14.253 4.081 15 5 15h1.667c.919 0 1.666-.748 1.666-1.667v-1.666c0-.92-.747-1.667-1.666-1.667M5 13.333v-1.666h1.667v1.666zM15.833 1.667H15V.833a.833.833 0 1 0-1.667 0v.834H6.667V.833A.833.833 0 1 0 5 .833v.834h-.833A4.17 4.17 0 0 0 0 5.833v10A4.17 4.17 0 0 0 4.167 20h11.666A4.17 4.17 0 0 0 20 15.833v-10a4.17 4.17 0 0 0-4.167-4.166M4.167 3.333h11.666c1.379 0 2.5 1.122 2.5 2.5v.834H1.667v-.834c0-1.378 1.121-2.5 2.5-2.5m11.666 15H4.167a2.503 2.503 0 0 1-2.5-2.5v-7.5h16.666v7.5c0 1.379-1.121 2.5-2.5 2.5" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "arrow-up": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m8.855 4.94-2.15-2.145a1 1 0 0 0-1.41 0L3.145 4.94a.5.5 0 1 0 .71.705L5.5 4v5.5a.5.5 0 0 0 1 0V4l1.645 1.645a.5.5 0 0 0 .71-.705" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "billing-tab-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M20 5.833v10.105a4.16 4.16 0 0 1-3.126 4.035.834.834 0 0 1-.415-1.613 2.5 2.5 0 0 0 1.874-2.422V8.333h-2.5a.833.833 0 1 1 0-1.666h2.5v-.834c0-1.378-1.121-2.5-2.5-2.5H4.167a2.503 2.503 0 0 0-2.5 2.5v.834h2.5a.834.834 0 0 1 0 1.666h-2.5v7.605c0 1.142.77 2.138 1.874 2.422a.832.832 0 1 1-.415 1.613A4.164 4.164 0 0 1 0 15.938V5.833a4.17 4.17 0 0 1 4.167-4.166H5V.833a.834.834 0 0 1 1.667 0v.834h6.666V.833a.833.833 0 1 1 1.667 0v.834h.833A4.17 4.17 0 0 1 20 5.833m-3.75 7.917a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0m-2.917 1.563a2.18 2.18 0 0 0-1.827-2.156L8.768 12.7a.52.52 0 0 1 .086-1.033h2.203c.296 0 .573.16.722.416.229.4.739.535 1.139.304a.83.83 0 0 0 .303-1.138A2.51 2.51 0 0 0 11.056 10h-.223a.834.834 0 0 0-1.667 0h-.314c-1.205 0-2.186.981-2.186 2.187 0 1.073.768 1.98 1.826 2.156l2.739.457a.52.52 0 0 1-.086 1.033H8.942a.84.84 0 0 1-.723-.416.832.832 0 1 0-1.442.834 2.51 2.51 0 0 0 2.165 1.25h.223a.834.834 0 0 0 1.667 0h.313a2.19 2.19 0 0 0 2.187-2.187z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  bold: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1M328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9z" />
      </g>
    ),
    viewBox: { width: 1024, height: 1024 },
    defaultSize: { width: 24, height: 24 },
  },

  // Referral bonus medal — used by the physician Referral surface (nav tab +
  // stat cards). Fill uses the icon CSS var so it inherits the surrounding
  // color (nav active state, IconBadge color variant, etc.).
  bonus: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12.178 7.893c.205-.362.322-.78.322-1.226 0-1.379-1.121-2.5-2.5-2.5h-.833c-.92 0-1.667.747-1.667 1.666v5c0 .92.748 1.667 1.667 1.667h1.667a2.5 2.5 0 0 0 1.344-4.607m-3.011-2.06H10A.834.834 0 0 1 10 7.5h-.833zm1.667 5H9.167V9.167h1.667a.834.834 0 0 1 0 1.666m8.846 4.65-2.667-2.665a8.27 8.27 0 0 0 1.32-4.485C18.334 3.738 14.596 0 10 0S1.667 3.738 1.667 8.333c0 1.66.493 3.203 1.332 4.503l-2.65 2.649a1.17 1.17 0 0 0-.258 1.288c.186.454.607.737 1.098.737H2.49v1.302c0 .744.608 1.189 1.195 1.189.314 0 .6-.121.831-.35l3.287-3.287c.7.193 1.435.303 2.197.303.77 0 1.511-.113 2.22-.309l3.294 3.294c.229.228.515.349.829.349.587 0 1.195-.445 1.195-1.19V17.51h1.302c.491 0 .912-.283 1.096-.736.186-.45.087-.945-.258-1.29zm-15.522 2.17v-1.81h-1.81l1.694-1.694a8.4 8.4 0 0 0 2.07 1.55zm-.824-9.32A6.674 6.674 0 0 1 10 1.667a6.674 6.674 0 0 1 6.667 6.666A6.674 6.674 0 0 1 10 15a6.674 6.674 0 0 1-6.666-6.667m12.538 7.51v1.809l-1.963-1.964a8.4 8.4 0 0 0 2.063-1.556l1.71 1.71z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  bookmark: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10.069 12a1.4 1.4 0 0 1-.994-.418L6 8.526l-3.075 3.06a1.4 1.4 0 0 1-1.547.304A1.4 1.4 0 0 1 .5 10.577V2.5A2.5 2.5 0 0 1 3 0h6a2.5 2.5 0 0 1 2.5 2.5v8.077a1.4 1.4 0 0 1-.875 1.312 1.4 1.4 0 0 1-.556.111M3 1a1.5 1.5 0 0 0-1.5 1.5v8.077a.422.422 0 0 0 .719.3l3.431-3.41a.5.5 0 0 1 .705 0l3.428 3.409a.422.422 0 0 0 .718-.3V2.5a1.5 1.5 0 0 0-1.5-1.5z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "browser-window": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12.667.667H3.333A3.335 3.335 0 0 0 0 4v8a3.335 3.335 0 0 0 3.333 3.333h9.334A3.334 3.334 0 0 0 16 12V4A3.335 3.335 0 0 0 12.667.667M3.333 2h9.334c1.1 0 2 .9 2 2v1.333H1.333V4c0-1.1.9-2 2-2m9.334 12H3.333c-1.1 0-2-.9-2-2V6.667h13.334V12c0 1.1-.9 2-2 2" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  browser: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 1.667h-7.5a4.17 4.17 0 0 0-4.166 4.166v5c0 2.3 1.866 4.167 4.166 4.167h7.5c2.3 0 4.167-1.867 4.167-4.167v-5c0-2.3-1.867-4.166-4.167-4.166m-7.5 1.666h7.5c1.084 0 2 .7 2.35 1.667h-12.2a2.49 2.49 0 0 1 2.35-1.667m7.5 10h-7.5a2.507 2.507 0 0 1-2.5-2.5V6.667h12.5v4.166c0 1.375-1.125 2.5-2.5 2.5M14.167 17.5a.836.836 0 0 1-.834.833H4.167A4.17 4.17 0 0 1 0 14.167V8.042a4.16 4.16 0 0 1 1.042-2.759.832.832 0 1 1 1.25 1.1 2.5 2.5 0 0 0-.625 1.65v6.125c0 1.375 1.125 2.5 2.5 2.5h9.166c.459 0 .834.375.834.834z" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  // Body
  bug: {
    path: (
      <>
        <path fill="none" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="2" d="M14 21.71A7 7 0 0 1 5 15v-3.062A3.94 3.94 0 0 1 8.938 8h6.124A3.94 3.94 0 0 1 19 11.938V15a6.98 6.98 0 0 1-2 4.899" />
        <path fill="var(--icon-fill, currentColor)" d="M8.25 7.5a.75.75 0 0 0-1.5 0zm-.615-2.917a.75.75 0 1 0 1.246.834zM17.25 8.5v-1h-1.5v1zm-10.5-1v1h1.5v-1zm10.5 0c0-2.9-2.35-5.25-5.25-5.25v1.5a3.75 3.75 0 0 1 3.75 3.75zM12 2.25a5.25 5.25 0 0 0-4.365 2.333l1.246.834A3.75 3.75 0 0 1 12 3.75z" />
        <path fill="none" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="2" d="M19 14h3M5 14H2M14.5 3.5 17 2M9.5 3.5 7 2M20.5 20l-2-.8m-15 .8 2-.8M20.5 8l-2 .8M3.5 8l2 .8M12 21.5V15" />
      </>
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 16, height: 16 },
  },

  calculator: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12 16H4a3.337 3.337 0 0 1-3.333-3.333V3.333A3.337 3.337 0 0 1 4 0h8a3.337 3.337 0 0 1 3.333 3.333v9.334A3.337 3.337 0 0 1 12 16M4 1.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2zm6.667 5.334H5.333a2 2 0 0 1 0-4h5.334a2 2 0 0 1 0 4M5.333 4a.667.667 0 0 0 0 1.333h5.334a.667.667 0 1 0 0-1.333zM4 8.667A.667.667 0 1 0 4 10a.667.667 0 0 0 0-1.333m2.667 0a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m2.666 0a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333M4 11.333a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333m2.667 0a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333M12 8.667A.667.667 0 1 0 12 10a.667.667 0 0 0 0-1.334M12.667 12a.666.666 0 0 0-.667-.667H9.333a.667.667 0 0 0 0 1.334H12a.667.667 0 0 0 .667-.667" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "calendar-appointment": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M4 6H3c-.551 0-1 .449-1 1v1c0 .552.449 1 1 1h1c.551 0 1-.448 1-1V7c0-.551-.449-1-1-1M3 8V7h1v1zm6.5-7H9V.5a.5.5 0 1 0-1 0V1H4V.5a.5.5 0 1 0-1 0V1h-.5A2.503 2.503 0 0 0 0 3.5v6C0 10.879 1.122 12 2.5 12h7c1.379 0 2.5-1.121 2.5-2.5v-6C12 2.122 10.879 1 9.5 1m-7 1h7c.827 0 1.5.673 1.5 1.5V4H1v-.5C1 2.673 1.673 2 2.5 2m7 9h-7C1.673 11 1 10.327 1 9.5V5h10v4.5c0 .827-.673 1.5-1.5 1.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "calendar-minus": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19 2h-1V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5M5 4h14c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3m14 18H5c-1.654 0-3-1.346-3-3v-9h20v9c0 1.654-1.346 3-3 3m-3-6a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1" />
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 20, height: 20 },
  },

  "calendar-plus": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 1.667H15V.833a.834.834 0 0 0-1.667 0v.834H6.667V.833A.834.834 0 0 0 5 .833v.834h-.833A4.17 4.17 0 0 0 0 5.833v10A4.17 4.17 0 0 0 4.167 20h11.666A4.17 4.17 0 0 0 20 15.833v-10a4.17 4.17 0 0 0-4.167-4.166M4.167 3.333h11.666c1.379 0 2.5 1.122 2.5 2.5v.834H1.667v-.834c0-1.378 1.121-2.5 2.5-2.5m11.666 15H4.167a2.503 2.503 0 0 1-2.5-2.5v-7.5h16.666v7.5c0 1.379-1.121 2.5-2.5 2.5m-2.5-5c0 .46-.373.834-.833.834h-1.667v1.666a.834.834 0 0 1-1.666 0v-1.666H7.5a.834.834 0 0 1 0-1.667h1.667v-1.667a.834.834 0 0 1 1.666 0V12.5H12.5c.46 0 .833.373.833.833" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  calendar: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M12.667 1.333H12V.667a.666.666 0 1 0-1.333 0v.666H5.333V.667A.667.667 0 1 0 4 .667v.666h-.667A3.337 3.337 0 0 0 0 4.667v8A3.337 3.337 0 0 0 3.333 16h9.334A3.337 3.337 0 0 0 16 12.667v-8a3.34 3.34 0 0 0-3.333-3.334M1.333 4.667a2 2 0 0 1 2-2h9.334a2 2 0 0 1 2 2v.666H1.333zm11.334 10H3.333a2 2 0 0 1-2-2v-6h13.334v6a2 2 0 0 1-2 2" />
        <path fill="var(--icon-fill, currentColor)" d="M8 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.667 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.333 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Calendar with an X. Sibling of `calendar-minus` / `calendar-plus`, which
  // are the only other calendar-with-a-mark glyphs in the registry.
  // Pixel-identical to the `assets/icons/cancel-appointment.svg` nothing ever
  // imported, which Phase 4 deleted in favour of this.
  "cancel-appointment": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="m13.09 11.423-1.912 1.91 1.911 1.911a.832.832 0 1 1-1.178 1.178L10 14.513l-1.91 1.91a.83.83 0 0 1-1.18 0 .83.83 0 0 1 0-1.178l1.912-1.91-1.911-1.912a.832.832 0 1 1 1.178-1.178L10 12.155l1.91-1.91a.832.832 0 1 1 1.18 1.178M20 5.833v10A4.17 4.17 0 0 1 15.833 20H4.167A4.17 4.17 0 0 1 0 15.833v-10a4.17 4.17 0 0 1 4.167-4.166H5V.833a.833.833 0 1 1 1.667 0v.834h6.666V.833a.833.833 0 1 1 1.667 0v.834h.833A4.17 4.17 0 0 1 20 5.833m-18.333 0v.834h16.666v-.834c0-1.378-1.121-2.5-2.5-2.5H4.167a2.503 2.503 0 0 0-2.5 2.5m16.666 10v-7.5H1.667v7.5c0 1.379 1.121 2.5 2.5 2.5h11.666c1.379 0 2.5-1.121 2.5-2.5" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  captions: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="18" height="14" x="3" y="5" rx="2" ry="2" />
        <path d="M7 15h4m4 0h2M7 11h2m4 0h4" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  car: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M24 8.5A1.5 1.5 0 0 0 22.5 7s-.584 0-.625.008a30 30 0 0 0-2.562-3.959 3.9 3.9 0 0 0-1.978-1.357c-1.761-.856-8.909-.856-10.67 0a3.9 3.9 0 0 0-1.978 1.357 30 30 0 0 0-2.562 3.959C2.084 7 1.5 7 1.5 7A1.5 1.5 0 0 0 0 8.5V15a4 4 0 0 0 2 3.463V20a3 3 0 0 0 6 0v-1h8v1a3 3 0 0 0 6 0v-1.537A4 4 0 0 0 24 15zM6.274 4.266a1.9 1.9 0 0 1 .967-.659c1.519-.751 8-.751 9.518 0a1.9 1.9 0 0 1 .967.659 28.6 28.6 0 0 1 3.72 6.49 65.4 65.4 0 0 0-18.892 0 28.6 28.6 0 0 1 3.72-6.49M6 20a1 1 0 1 1-2 0v-1h2zm14 0a1 1 0 0 1-2 0v-1h2zm0-3H4a2 2 0 0 1-2-2v-2.143A76 76 0 0 1 12 12c3.349.065 6.69.35 10 .857V15a2 2 0 0 1-2 2M6 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m14 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 16, height: 16 },
  },

  "caret-right": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.24 6.434a.5.5 0 0 0 0-.868L3.748 2.427A.5.5 0 0 0 3 2.861v6.277a.5.5 0 0 0 .748.434z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  check: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M18.599 3.693 7.083 15.207a.834.834 0 0 1-1.18 0L1.448 10.75a.834.834 0 1 0-1.181 1.18l4.455 4.455a2.507 2.507 0 0 0 3.542 0L19.78 4.873a.833.833 0 0 0-.59-1.426.83.83 0 0 0-.591.246" />
    ),
    viewBox: { width: 21, height: 20 },
  },

  "checkbox-checked": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M18.6 3.693 7.083 15.207a.834.834 0 0 1-1.181 0L1.45 10.75a.834.834 0 1 0-1.181 1.18l4.455 4.455a2.507 2.507 0 0 0 3.541 0L19.78 4.873a.83.83 0 0 0 0-1.18.833.833 0 0 0-1.18 0" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  checklist: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M2.667 4a2 2 0 0 1-1.415-.586l-1.03-.916a.667.667 0 0 1 .889-.996l1.056.942a.667.667 0 0 0 .97.027L5.542.184a.667.667 0 0 1 .918.965L4.067 3.425a1.98 1.98 0 0 1-1.4.575M16 2.666A.667.667 0 0 0 15.333 2H8.667a.667.667 0 0 0 0 1.333h6.666A.667.667 0 0 0 16 2.666M4.067 8.758l2.392-2.276a.667.667 0 1 0-.918-.965l-2.4 2.287a.68.68 0 0 1-.943 0l-1.06-1.056a.667.667 0 0 0-.943.942l1.057 1.057a2 2 0 0 0 2.817.011zM16 8a.667.667 0 0 0-.667-.667H8.667a.667.667 0 0 0 0 1.333h6.666A.667.667 0 0 0 16 8M4.067 14.092l2.39-2.276a.666.666 0 1 0-.92-.966l-2.4 2.288a.667.667 0 0 1-.97-.027l-1.056-.943a.667.667 0 1 0-.888.996l1.029.916a2 2 0 0 0 2.817.012zM16 13.333a.667.667 0 0 0-.667-.667H8.667a.666.666 0 1 0 0 1.334h6.666a.667.667 0 0 0 .667-.667" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  checkmark: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M13.3 3.3a1 1 0 0 1 1.4 1.4l-8 8a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4L6 10.58l7.3-7.3Z" />
    ),
    viewBox: { width: 16, height: 16 },
    defaultSize: { width: 12, height: 12 },
  },

  "chevron-right": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m12 10 4 4-4 4" />
    ),
    viewBox: { width: 28, height: 28 },
    defaultSize: { width: 16, height: 16 },
  },

  "circle-check": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M6.667 15.333A.666.666 0 0 1 6 16H3.333A3.337 3.337 0 0 1 0 12.667V3.333A3.337 3.337 0 0 1 3.333 0h5.334A3.337 3.337 0 0 1 12 3.333v1.334a.666.666 0 1 1-1.333 0V3.333c0-1.102-.898-2-2-2H3.333c-1.102 0-2 .898-2 2v9.334c0 1.102.898 2 2 2H6c.369 0 .667.298.667.666M9.333 4a.666.666 0 0 0-.666-.667H3.333a.666.666 0 1 0 0 1.334h5.334A.666.666 0 0 0 9.333 4M6.667 7.333A.666.666 0 0 0 6 6.667H3.333a.666.666 0 1 0 0 1.333H6a.666.666 0 0 0 .667-.667M3.333 10a.666.666 0 1 0 0 1.333h1.334a.666.666 0 1 0 0-1.333zM16 11.333A4.673 4.673 0 0 1 11.333 16a4.673 4.673 0 0 1-4.666-4.667 4.673 4.673 0 0 1 4.666-4.666A4.673 4.673 0 0 1 16 11.333m-1.333 0A3.337 3.337 0 0 0 11.333 8 3.337 3.337 0 0 0 8 11.333a3.337 3.337 0 0 0 3.333 3.334 3.337 3.337 0 0 0 3.334-3.334m-2.128-.827-1.482 1.423a.25.25 0 0 1-.348.001l-.754-.739a.666.666 0 1 0-.933.952l.754.74c.307.299.708.449 1.109.449.4 0 .8-.15 1.102-.447l1.475-1.416a.667.667 0 0 0-.923-.962z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "circle-close-filled": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m2.667 9.725a.667.667 0 1 1-.942.942L8 8.943l-1.724 1.724a.667.667 0 0 1-.943-.943L7.057 8 5.333 6.276a.667.667 0 0 1 .943-.943L8 7.057l1.725-1.724a.667.667 0 1 1 .942.942L8.943 8z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "circle-dashed": {
    path: (
      <circle cx="10" cy="10" r="7.25" fill="none" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeDasharray="2.847 2.847" strokeWidth="1.5" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "clear-formatting": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M2.75 2a.5.5 0 0 0-.485.379l-.25 1a.5.5 0 1 0 .97.242L3.14 3h2.723l-1.4 8h-.736a.5.5 0 0 0 0 1h2.295a5.6 5.6 0 0 1 0-1h-.544l1.4-8H9.86l-.095.379a.5.5 0 1 0 .97.242l.25-1A.5.5 0 0 0 10.5 2zM1.5 13h4.707q.149.524.393 1H1.5a.5.5 0 0 1 0-1M16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.646-1.146a.5.5 0 0 0-.708-.708L11.5 10.793l-1.146-1.147a.5.5 0 0 0-.708.708l1.147 1.146-1.147 1.146a.5.5 0 0 0 .708.708l1.146-1.147 1.146 1.147a.5.5 0 0 0 .708-.708L12.207 11.5z" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
    defaultSize: { width: 24, height: 24 },
  },

  "clipboard-list": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10.667 12H8a.666.666 0 1 1 0-1.333h2.667a.666.666 0 1 1 0 1.333m3.333.667v-8a3.337 3.337 0 0 0-3.333-3.334h-.114A2 2 0 0 0 8.667 0H7.333c-.869 0-1.61.557-1.886 1.333h-.114A3.337 3.337 0 0 0 2 4.667v8A3.337 3.337 0 0 0 5.333 16h5.334A3.337 3.337 0 0 0 14 12.667m-8-10A.666.666 0 0 0 6.667 2c0-.369.299-.667.666-.667h1.334c.367 0 .666.299.666.667s.299.667.667.667h.667c1.102 0 2 .897 2 2v8c0 1.102-.898 2-2 2H5.333c-1.102 0-2-.898-2-2v-8c0-1.103.898-2 2-2zm-.667 8a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m6-2A.666.666 0 0 0 10.667 8H8a.666.666 0 1 0 0 1.333h2.667a.666.666 0 0 0 .666-.666m-6-.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m6-2a.666.666 0 0 0-.666-.667H8a.666.666 0 1 0 0 1.334h2.667A.666.666 0 0 0 11.333 6m-6-.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  clock: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M6 0a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6m0 11a5 5 0 1 1 0-9.999A5 5 0 0 1 6 11" />
        <path d="M6 3a.5.5 0 0 0-.5.5v2.162L3.815 6.719a.501.501 0 1 0 .53.85l1.92-1.2A.5.5 0 0 0 6.5 5.94V3.5A.5.5 0 0 0 6 3" />
      </g>
    ),
    viewBox: { width: 12, height: 12 },
  },

  close: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M10.667 5.333a.667.667 0 0 0-.943 0L8 7.057 6.276 5.333a.667.667 0 0 0-.942.943L7.058 8 5.334 9.724a.667.667 0 0 0 .942.942L8 8.943l1.724 1.723a.667.667 0 0 0 .943-.942L8.943 8l1.724-1.724a.667.667 0 0 0 0-.943" />
        <path fill="var(--icon-fill, currentColor)" d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14.667A6.666 6.666 0 1 1 14.667 8 6.674 6.674 0 0 1 8 14.667" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "closed-eye": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.793 6.76a.654.654 0 1 1-1.135.653l-.917-1.605a7 7 0 0 1-1.643.754l.288 1.722a.653.653 0 0 1-1.29.216l-.28-1.676a7.4 7.4 0 0 1-1.636 0l-.277 1.678a.653.653 0 0 1-1.29-.218l.289-1.726a7 7 0 0 1-1.643-.755l-.917 1.61A.654.654 0 0 1 .207 6.76L1.21 5.01a9 9 0 0 1-.942-.996.653.653 0 0 1 1.015-.821c.873 1.08 2.4 2.37 4.717 2.37s3.844-1.29 4.717-2.37a.653.653 0 0 1 1.016.82q-.432.536-.943.997z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  collapse: {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m14 16-4-4-4 4M6 4l4 4 4-4" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  comment: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M10.712.025A10.02 10.02 0 0 0 2.929 2.93a10.02 10.02 0 0 0-2.904 7.782c.367 5.295 5.054 9.289 10.903 9.289h4.906C18.287 20 20 17.996 20 15.127v-4.846C20 4.892 15.92.386 10.712.025m7.622 15.103c0 1.918-1.005 3.206-2.5 3.206h-4.906c-5.044 0-8.93-3.254-9.24-7.738a8.35 8.35 0 0 1 2.42-6.488 8.35 8.35 0 0 1 6.488-2.42c4.34.3 7.738 4.075 7.738 8.593v4.847m-4.167-5.127c0 .46-.373.833-.833.833h-2.5v2.5a.834.834 0 0 1-1.667 0v-2.5h-2.5a.834.834 0 0 1 0-1.667h2.5v-2.5a.834.834 0 0 1 1.667 0v2.5h2.5c.46 0 .833.373.833.834" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  "contact-book": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.583 5.417a2.083 2.083 0 1 1 4.166-.001 2.083 2.083 0 0 1-4.166 0m-1.33 6.129a.833.833 0 0 0 1.145-.28A2.7 2.7 0 0 1 11.667 10c.912 0 1.802.497 2.268 1.266a.834.834 0 0 0 1.426-.865 4.34 4.34 0 0 0-3.694-2.068 4.34 4.34 0 0 0-3.695 2.068.834.834 0 0 0 .281 1.145m10.08-7.38v11.667A4.17 4.17 0 0 1 14.167 20H5a3.337 3.337 0 0 1-3.333-3.333v-12.5A4.17 4.17 0 0 1 5.833 0h8.334a4.17 4.17 0 0 1 4.166 4.167m-4.166-2.5h-7.5v11.667h10V4.167c0-1.379-1.122-2.5-2.5-2.5m-10.834 2.5v9.63A3.3 3.3 0 0 1 5 13.334V1.82a2.5 2.5 0 0 0-1.667 2.347m13.334 11.667V15H5c-.92 0-1.667.748-1.667 1.667S4.081 18.333 5 18.333h9.167c1.378 0 2.5-1.121 2.5-2.5" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  copy: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10.833 16.667A4.17 4.17 0 0 0 15 12.5V5.203a3.3 3.3 0 0 0-.977-2.358L12.155.977A3.3 3.3 0 0 0 9.798 0H5.833a4.17 4.17 0 0 0-4.166 4.167V12.5a4.17 4.17 0 0 0 4.166 4.167zm-7.5-4.167V4.167a2.5 2.5 0 0 1 2.5-2.5s4.1.011 4.167.02v1.646A1.667 1.667 0 0 0 11.667 5h1.646c.009.068.02 7.5.02 7.5a2.5 2.5 0 0 1-2.5 2.5h-5a2.5 2.5 0 0 1-2.5-2.5m15-5.833v9.166A4.17 4.17 0 0 1 14.167 20h-7.5a.833.833 0 1 1 0-1.667h7.5a2.5 2.5 0 0 0 2.5-2.5V6.667a.834.834 0 0 1 1.666 0" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  cross: {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="2" d="m1 1 8 8m0-8L1 9" />
    ),
    viewBox: { width: 10, height: 10 },
  },

  "deposition-appointment-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M20 15.553v.28a1.668 1.668 0 0 1-1.946 1.644c-.82-.133-1.387-.902-1.387-1.732v-.192l.711-2.016-1.545-.29v5.087H17.5a.833.833 0 1 1 0 1.667h-5a.833.833 0 1 1 0-1.667h1.667v-5.4l-1.46-.273.717 2.005v.479h-.01a1.714 1.714 0 0 1-2.056 1.486C10.55 16.469 10 15.704 10 14.88v-.203l.883-2.816a1.383 1.383 0 0 1 1.572-.946l1.712.318v-.4a.833.833 0 1 1 1.666 0v.709l2.009.372c.562.104 1.027.5 1.22 1.038zM2.5 5c0-2.757 2.242-5 5-5s5 2.243 5 5-2.242 5-5 5-5-2.242-5-5m1.667 0A3.337 3.337 0 0 0 7.5 8.333 3.337 3.337 0 0 0 10.833 5 3.337 3.337 0 0 0 7.5 1.667 3.337 3.337 0 0 0 4.167 5M7.5 11.667c-4.135 0-7.5 3.364-7.5 7.5a.833.833 0 1 0 1.667 0A5.84 5.84 0 0 1 7.5 13.333a.833.833 0 1 0 0-1.666" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "doctor-chat": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.997 2.376A2.49 2.49 0 0 0 9.624.003a2.42 2.42 0 0 0-1.802.682A2.67 2.67 0 0 0 7 2.607v1.23C7 4.636 7.518 5 8 5h1.39c.725 0 1.426-.3 1.925-.823a2.42 2.42 0 0 0 .682-1.8m-1.406 1.111c-.31.326-.748.513-1.2.513l-1.357.018S8 3.972 8 3.836V2.607c0-.45.187-.888.512-1.198.278-.265.698-.406 1.063-.406.774.037 1.386.65 1.423 1.423.019.389-.125.766-.406 1.062zM1.5 3A3.004 3.004 0 0 1 5.7.25a.5.5 0 0 1-.4.916A2.002 2.002 0 0 0 2.5 3a2.002 2.002 0 0 0 2.8 1.834.5.5 0 1 1 .4.916A3.003 3.003 0 0 1 1.5 3m8.5 8.5a.5.5 0 1 1-1 0 3.5 3.5 0 0 0-2-3.162v1.248c.582.207 1 .762 1 1.414v.5a.5.5 0 1 1-1 0V11a.5.5 0 0 0-1 0v.5a.5.5 0 1 1-1 0V11c0-.652.418-1.207 1-1.414v-1.55A3.5 3.5 0 0 0 5.5 8h-1q-.523.002-1 .146v1.489a1 1 0 1 1-1 0V8.63A3.5 3.5 0 0 0 1 11.5a.5.5 0 1 1-1 0C0 9.02 2.019 7 4.5 7h1C7.981 7 10 9.02 10 11.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "down-arrow": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m5.241 12.607 3.584 3.575a1.666 1.666 0 0 0 2.35 0l3.583-3.575a.833.833 0 1 0-1.183-1.175l-2.742 2.742V5.007a.833.833 0 1 0-1.667 0v9.167l-2.741-2.742a.834.834 0 0 0-1.184 1.175" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "down-chevron": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m6 8 4 4 4-4" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  down: {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m2 4 4 4 4-4" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  downloads: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M6.585 12.081a2 2 0 0 0 2.83 0l2.14-2.14A.667.667 0 0 0 10.613 9l-1.951 1.951L8.667.667a.667.667 0 0 0-1.334 0l-.006 10.272L5.387 9a.667.667 0 1 0-.942.943z" />
        <path fill="var(--icon-fill, currentColor)" d="M15.333 10.667a.667.667 0 0 0-.666.666V14a.667.667 0 0 1-.667.667H2A.667.667 0 0 1 1.333 14v-2.667a.667.667 0 0 0-1.333 0V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.667a.667.667 0 0 0-.667-.666" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  draft: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M7.5 13.334h1.325c.892 0 1.725-.35 2.358-.975l8.084-8.092c.475-.475.733-1.1.733-1.767s-.258-1.291-.733-1.766a2.5 2.5 0 0 0-3.534 0L7.642 8.825a3.3 3.3 0 0 0-.975 2.359v1.325c0 .458.375.833.833.833zM18.092 1.909a.83.83 0 0 1 .241.591.83.83 0 0 1-.241.592l-1.075 1.075-1.175-1.175 1.075-1.075a.83.83 0 0 1 1.175 0zm-9.759 9.266c0-.441.175-.866.492-1.175l5.833-5.833 1.175 1.175L10 11.175a1.65 1.65 0 0 1-1.175.492h-.492zM20 19.167a.836.836 0 0 1-.833.833c-1.284 0-1.909-.933-2.359-1.625-.416-.625-.625-.875-.975-.875-.425 0-.75.367-1.258.959C13.992 19.15 13.267 20 12.05 20s-1.933-.858-2.5-1.558c-.483-.583-.8-.942-1.217-.942-.325 0-.525.209-.966.759-.6.733-1.425 1.741-3.2 1.741A4.17 4.17 0 0 1 0 15.834c0-2.3 1.867-4.167 4.167-4.167.458 0 .833.375.833.833a.836.836 0 0 1-.833.834 2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5.983 0 1.391-.5 1.908-1.134.5-.608 1.117-1.366 2.258-1.366 1.225 0 1.934.858 2.5 1.558.484.583.8.942 1.217.942s.75-.367 1.258-.959c.584-.691 1.309-1.541 2.525-1.541 1.217 0 1.909.933 2.359 1.625.416.625.625.875.975.875.458 0 .833.375.833.833" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // A 2x3 dot grid; nothing else in the registry is dotted. Re-gridded to
  // 10x17: the legacy source put the bottom pair at y=20.5 on a 20 grid, so
  // the viewBox clipped it flat. Same six circles, all of them now visible.
  "drag-handle": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <circle cx="1.5" cy="1.5" r="1.5" />
        <circle cx="8.5" cy="1.5" r="1.5" />
        <circle cx="1.5" cy="8.5" r="1.5" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <circle cx="1.5" cy="15.5" r="1.5" />
        <circle cx="8.5" cy="15.5" r="1.5" />
      </g>
    ),
    viewBox: { width: 10, height: 17 },
  },

  duplicate: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16.25 0h-5.833a3.755 3.755 0 0 0-3.75 3.75v9.167a2.92 2.92 0 0 0 2.916 2.916h6.667a3.755 3.755 0 0 0 3.75-3.75V3.75A3.755 3.755 0 0 0 16.25 0m-5.833 1.667h5.833c1.148 0 2.083.934 2.083 2.083V10h-8.75c-.446 0-.87.102-1.25.282V3.75c0-1.15.935-2.083 2.084-2.083m5.833 12.5H9.583c-.689 0-1.25-.561-1.25-1.25 0-.69.561-1.25 1.25-1.25h8.75v.416c0 1.15-.935 2.084-2.083 2.084m-4.03 3.583a.83.83 0 0 1-.013 1.178A3.73 3.73 0 0 1 9.583 20H2.917A2.92 2.92 0 0 1 0 17.083V7.917a3.755 3.755 0 0 1 3.75-3.75h.417a.833.833 0 1 1 0 1.666H3.75a2.086 2.086 0 0 0-2.083 2.084v6.531c.379-.18.803-.281 1.25-.281h1.25a.833.833 0 1 1 0 1.666h-1.25c-.69 0-1.25.561-1.25 1.25 0 .69.56 1.25 1.25 1.25h6.666a2.07 2.07 0 0 0 1.458-.595.833.833 0 0 1 1.178.012" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "email-letter": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.5.5h-7A2.503 2.503 0 0 0 0 3v6a2.503 2.503 0 0 0 2.5 2.5h7A2.503 2.503 0 0 0 12 9V3A2.503 2.503 0 0 0 9.5.5m-7 1h7a1.5 1.5 0 0 1 1.39.943l-3.829 3.83a1.503 1.503 0 0 1-2.122 0L1.11 2.443A1.5 1.5 0 0 1 2.5 1.5m7 9h-7A1.5 1.5 0 0 1 1 9V3.75l3.232 3.23a2.503 2.503 0 0 0 3.536 0L11 3.75V9a1.5 1.5 0 0 1-1.5 1.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  email: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16 6.667v6A3.337 3.337 0 0 1 12.667 16H3.333A3.337 3.337 0 0 1 0 12.667V5.333A3.337 3.337 0 0 1 3.333 2h5.334a.667.667 0 0 1 0 1.333H3.333A1.99 1.99 0 0 0 1.574 4.4l5.011 5.012a2.005 2.005 0 0 0 2.83 0l2.547-2.545a.667.667 0 0 1 .943.942l-2.548 2.548a3.34 3.34 0 0 1-4.714 0l-4.31-4.31v6.62a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2v-6a.667.667 0 1 1 1.333 0m-4.667-3.334h1.334v1.334a.667.667 0 1 0 1.333 0V3.333h1.333a.667.667 0 1 0 0-1.333H14V.667a.666.666 0 1 0-1.333 0V2h-1.334a.667.667 0 0 0 0 1.333" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Envelope with a "no" mark — pauses/stops scheduled comms to a party
  // (GET-3285). Fill uses currentColor so it inherits the menu-item color.
  "envelope-off": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19 10a5 5 0 1 0-.006-10A5 5 0 0 0 19 10m2.122-2.876a3 3 0 0 1-3.406.576L21.7 3.716a3 3 0 0 1-.578 3.406zm-4.244-4.246a3 3 0 0 1 3.406-.578L16.3 6.284a3 3 0 0 1 .578-3.406M24 12v7a5.006 5.006 0 0 1-5 5H5a5.006 5.006 0 0 1-5-5V8a5.006 5.006 0 0 1 5-5h6a1 1 0 1 1 0 2H5a2.99 2.99 0 0 0-2.639 1.6l7.517 7.518a3.01 3.01 0 0 0 4.244 0l1.87-1.836a1 1 0 0 1 1.4 1.428l-1.864 1.828a5 5 0 0 1-7.065-.006L2 9.071V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 0 1 2 0" />
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 20, height: 20 },
  },

  eraser: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.502 10.5H7.185l4.087-4.102c.97-.973.97-2.557 0-3.53L9.645 1.235A2.48 2.48 0 0 0 7.875.5c-.67 0-1.299.261-1.77.734L.73 6.588a2.505 2.505 0 0 0 0 3.529l.792.794c.372.375.888.589 1.417.589h8.562a.5.5 0 1 0 0-1m-4.69-8.559A1.5 1.5 0 0 1 7.875 1.5c.402 0 .779.157 1.062.441l1.627 1.633a1.504 1.504 0 0 1 0 2.117L8.079 8.186 4.325 4.419zM2.94 10.5a1 1 0 0 1-.709-.294l-.792-.794a1.5 1.5 0 0 1-.001-2.117l2.179-2.17 3.757 3.77-1.6 1.606z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  expand: {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m6 12 4 4 4-4m0-4-4-4-4 4" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  eye: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.766 5.772c-.018-.038-.428-.95-1.335-1.857C9.217 2.703 7.687 2.063 6 2.063c-1.688 0-3.217.64-4.43 1.852C.665 4.822.254 5.734.235 5.772a.57.57 0 0 0 0 .457c.018.038.428.95 1.336 1.856C2.783 9.297 4.312 9.937 6 9.937s3.217-.64 4.429-1.852c.907-.907 1.318-1.818 1.335-1.856a.57.57 0 0 0 .002-.457m-2.16 1.547C8.6 8.309 7.388 8.813 6 8.813S3.4 8.31 2.395 7.318A6.1 6.1 0 0 1 1.384 6a6.1 6.1 0 0 1 1.01-1.318C3.4 3.69 4.614 3.187 6 3.187s2.6.503 3.605 1.495c.396.391.736.835 1.011 1.318a6.1 6.1 0 0 1-1.01 1.318M6 3.938a2.062 2.062 0 1 0 0 4.124 2.062 2.062 0 0 0 0-4.124m0 3a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  fax: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M7.333 9c0-.553.447-1 1-1 .554 0 1 .447 1 1s-.446 1-1 1c-.553 0-1-.447-1-1m1 2.333c-.553 0-1 .447-1 1 0 .554.447 1 1 1 .554 0 1-.446 1-1 0-.553-.446-1-1-1M11.667 10c.553 0 1-.447 1-1s-.447-1-1-1c-.554 0-1 .447-1 1s.446 1 1 1m0 3.333c.553 0 1-.446 1-1 0-.553-.447-1-1-1-.554 0-1 .447-1 1 0 .554.446 1 1 1M16 4.16v8.507A3.334 3.334 0 0 1 12.667 16h-10A2.666 2.666 0 0 1 0 13.333v-8a2.666 2.666 0 1 1 5.333 0h1.334V2.667A2.666 2.666 0 0 1 9.333 0h2.507c.713 0 1.38.28 1.887.78l1.493 1.493c.493.494.78 1.18.78 1.887M4 5.333C4 4.6 3.4 4 2.667 4c-.734 0-1.334.6-1.334 1.333v8c0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334zm4 0h6.667V4.16c0-.053 0-.107-.014-.16h-1.32C12.6 4 12 3.4 12 2.667v-1.32c-.053 0-.107-.014-.16-.014H9.333C8.6 1.333 8 1.933 8 2.667zm6.667 1.334H5.333v6.666c0 .487-.133.94-.36 1.334h7.694c1.1 0 2-.9 2-2z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "file-img": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M5 7.917a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m13.333.82v7.096A4.17 4.17 0 0 1 14.167 20H5.833a4.17 4.17 0 0 1-4.166-4.167V4.167A4.17 4.17 0 0 1 5.833 0h3.763a5.8 5.8 0 0 1 4.125 1.708l2.904 2.904a5.8 5.8 0 0 1 1.708 4.126m-5.791-5.85a4.2 4.2 0 0 0-.875-.671v3.617c0 .46.374.834.833.834h3.617a4.2 4.2 0 0 0-.67-.875zM3.333 15.833l.002.07 4.217-4.216a2.875 2.875 0 0 1 4.063 0l.512.512a1.12 1.12 0 0 0 1.579 0l2.96-2.96v-.502q0-.203-.018-.404H12.5a2.503 2.503 0 0 1-2.5-2.5V1.686a4 4 0 0 0-.404-.02H5.833a2.503 2.503 0 0 0-2.5 2.5zm13.334 0v-4.238l-1.783 1.782a2.785 2.785 0 0 1-3.935 0l-.512-.512a1.21 1.21 0 0 0-1.707 0l-4.698 4.698a2.5 2.5 0 0 0 1.801.77h8.334c1.378 0 2.5-1.121 2.5-2.5" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "file-search": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.167" d="M9.333 2H4.667a1.333 1.333 0 0 0-1.334 1.333v9.334A1.333 1.333 0 0 0 4.667 14h2.666M9.333 2v3.333h3.334M12.667 5.333v2M11 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4M14 14l-1.6-1.6" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  file: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.333 9.333a.667.667 0 0 1-.666.667H5.333a.667.667 0 1 1 0-1.333h5.334a.667.667 0 0 1 .666.666m-2.666 2H5.333a.667.667 0 0 0 0 1.334h3.334a.667.667 0 0 0 0-1.334m6-4.343v5.677A3.337 3.337 0 0 1 11.333 16H4.667a3.337 3.337 0 0 1-3.334-3.333V3.333A3.337 3.337 0 0 1 4.667 0h3.01a4.64 4.64 0 0 1 3.3 1.367l2.322 2.324a4.63 4.63 0 0 1 1.368 3.299m-4.633-4.68a3.3 3.3 0 0 0-.7-.52v2.877a.667.667 0 0 0 .666.666h2.877a3.3 3.3 0 0 0-.52-.7zm3.3 4.68c0-.11-.022-.215-.032-.323H10a2 2 0 0 1-2-2V1.365c-.108-.01-.214-.032-.323-.032h-3.01a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "filter-clear": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.805 14.862 10.862 9.92l2.897-2.985c.602-.62.933-1.437.933-2.3 0-1.82-1.48-3.301-3.3-3.301H4.634c-.649 0-1.273.198-1.808.55L1.138.196a.666.666 0 1 0-.942.942l14.666 14.667a.665.665 0 0 0 .943 0 .666.666 0 0 0 0-.943M4.635 2.667h6.757a1.97 1.97 0 0 1 1.41 3.34L9.92 8.976 3.802 2.86c.26-.122.54-.193.832-.193m5.365 10v2.667a.668.668 0 0 1-1.066.533l-2.667-2A.67.67 0 0 1 6 13.333v-2.562L2.268 6.935a3.3 3.3 0 0 1-.67-1.007.667.667 0 0 1 1.227-.522q.144.338.398.599l3.922 4.03a.67.67 0 0 1 .189.464V13l1.333 1v-1.333a.667.667 0 1 1 1.333 0" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  filter: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10.086 0H3.914a1.916 1.916 0 0 0-1.353 3.268L5.5 6.207V8a.5.5 0 0 0 .2.4l2 1.5a.5.5 0 0 0 .8-.4V6.207l2.94-2.94A1.917 1.917 0 0 0 10.086 0zm.646 2.561L7.648 5.647A.5.5 0 0 0 7.5 6v2.5l-1-.75V6a.5.5 0 0 0-.146-.353L3.268 2.56A.915.915 0 0 1 3.915 1h6.171a.915.915 0 0 1 .646 1.561M6.5 10.5v1a.5.5 0 0 1-.8.4l-2-1.5a.5.5 0 0 1-.2-.4V8.207L.56 5.268a1.912 1.912 0 0 1 .116-2.814.5.5 0 1 1 .648.763.915.915 0 0 0-.056 1.345l3.086 3.085a.5.5 0 0 1 .146.354v1.75l1 .75a.5.5 0 1 1 1 0z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  flag: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m10.179 3.75 1.618-2.149a.99.99 0 0 0 .096-1.047.99.99 0 0 0-.895-.554H2C.897 0 0 .897 0 2v9.5a.5.5 0 1 0 1 0v-4h9.999a1 1 0 0 0 .895-.553 1 1 0 0 0-.096-1.048zM1 6.5V2c0-.552.448-1 1-1h8.999L9.154 3.449a.5.5 0 0 0 0 .602L10.999 6.5z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "folder-past-case": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.494 1.987H6.23a.5.5 0 0 1-.224-.052l-1.578-.79a1.5 1.5 0 0 0-.67-.158H2.493a2.503 2.503 0 0 0-2.5 2.5v6c0 .89.479 1.72 1.25 2.165a.5.5 0 1 0 .5-.865 1.51 1.51 0 0 1-.75-1.3v-4.5h10v4.5c0 .534-.288 1.032-.75 1.3a.499.499 0 1 0 .5.865 2.51 2.51 0 0 0 1.25-2.165v-5c0-1.378-1.122-2.5-2.5-2.5m-8.5 1.5c0-.827.673-1.5 1.5-1.5h1.263c.077 0 .155.018.224.053l1.578.79c.207.102.44.157.67.157h3.264c.651 0 1.201.42 1.408 1H.994zm4.995 2.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 6a2.503 2.503 0 0 1-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5 1.379 0 2.5 1.122 2.5 2.5 0 1.379-1.121 2.5-2.5 2.5m.854-2.353a.5.5 0 1 1-.707.707l-.5-.5a.5.5 0 0 1-.147-.354v-1a.5.5 0 1 1 1 0v.793z" />
    ),
    viewBox: { width: 12, height: 13 },
  },

  folder: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.5 1.5H6.236a.5.5 0 0 1-.223-.05L4.435.658A1.5 1.5 0 0 0 3.763.5H2.5A2.503 2.503 0 0 0 0 3v6a2.503 2.503 0 0 0 2.5 2.5h7A2.503 2.503 0 0 0 12 9V4a2.503 2.503 0 0 0-2.5-2.5m-7 0h1.264a.5.5 0 0 1 .224.05l1.578.79c.208.104.437.159.67.16H9.5a1.5 1.5 0 0 1 1.39.941L1 3.497V3a1.5 1.5 0 0 1 1.5-1.5m7 9h-7A1.5 1.5 0 0 1 1 9V4.497l10-.056V9a1.5 1.5 0 0 1-1.5 1.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  golf: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12 10.002a20.3 20.3 0 0 0-4.016.4l-.006-2.285 5.009-2.076a2 2 0 0 0 .271-3.4 1 1 0 0 0-.1-.065L8.9.214A2 2 0 0 0 6 2.002v8.914c-3.609 1.195-6 3.446-6 6.086 0 3.925 5.271 7 12 7s12-3.075 12-7-5.271-7-12-7m.073-5.745-4.1 1.7-.01-3.971zM12 22.002c-5.42 0-10-2.29-10-5 0-1.594 1.591-3.04 4-3.962v3.962a1 1 0 1 0 2 0l-.011-4.56a18.3 18.3 0 0 1 4.011-.44c5.42 0 10 2.29 10 5s-4.58 5-10 5m5-5a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 20, height: 20 },
  },

  help: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  highlighter: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m9 11-6 6v3h9l3-3" />
        <path d="m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  huddle: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.142 9.203a.664.664 0 0 1-.006.937c-.05.049-1.227 1.194-3.136 1.194S4.913 10.19 4.864 10.14a.667.667 0 1 1 .939-.947c.03.03.853.807 2.197.807s2.167-.778 2.201-.81a.667.667 0 0 1 .94.013m-5.475-1.87a1 1 0 1 0-.001-2 1 1 0 0 0 0 2m4.666-2a1 1 0 1 0 .001 2.001 1 1 0 0 0 0-2M16 8.228v4.44A3.337 3.337 0 0 1 12.667 16H8.722C4.055 16 .314 12.806.019 8.57a8.02 8.02 0 0 1 2.32-6.222A8.03 8.03 0 0 1 8.557.02C12.731.303 16 3.908 16 8.227m-1.333 0c0-3.62-2.724-6.641-6.2-6.877a6.676 6.676 0 0 0-5.185 1.94A6.68 6.68 0 0 0 1.35 8.478c.248 3.586 3.349 6.19 7.372 6.19h3.945c1.102 0 2-.898 2-2z" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  image: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  indent: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7.5 4H14M7.5 8H14m-6.5 4H14M2 5.5 4.5 8 2 10.5" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Indigo brand mark (the "iii" + block wordmark glyph). Used e.g. as the
  // "Indigo portal guides" tab icon. Fills use currentColor so it inherits the
  // surrounding text color (dark when the tab is active/hovered).
  "indigo-logo": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M4.726 9.375c1.517 0 2.848-2.294 2.848-4.603 0-1.391-.542-1.942-1.285-1.942-1.517 0-2.863 2.294-2.863 4.603 0 1.391.541 1.942 1.3 1.942M1.114 9.375c1.146 0 1.95-1.315 1.95-2.6 0-.871-.371-1.376-1.083-1.376C.821 5.4 0 6.745 0 8.03c0 .826.387 1.346 1.114 1.346M7.526 7.423c-.347 1.139.092 1.952.97 1.952H12V0H9.777l-.622 2.091z" />
    ),
    viewBox: { width: 12, height: 10 },
  },

  // Indy's glasses — the assistant's own mark, so its nav tab reads as Indy
  // rather than as one more `sparkles` AI action (that icon is shared by ~11
  // unrelated generate/populate surfaces). Stroked like `sort` so it recolours
  // on hover/active; the launcher's ten hand-drawn PNG variants carry far too
  // much line detail to survive at 16px, so this is a single simplified mark.
  // `fill="none"` is load-bearing: unlike the open paths in `sort`, these
  // lenses are closed, so the navbar's CSS `fill: currentColor` on the <svg>
  // would ink them solid (CSS beats the root's fill="none" attribute). Ink
  // spans y 6.15–17.8 (lens bottom + half-stroke), optical centre ~11.98 — two
  // units below the box centre, a visible ~1.6px sag next to full-bleed
  // siblings at the 16px navbar render. Recentre the ink, not the geometry.
  "indy-glasses": {
    path: (
      <g fill="none" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(0 -2)">
        <circle cx="5.05" cy="13.35" r="3.7" />
        <circle cx="14.95" cy="13.35" r="3.7" />
        <path d="M8.72 12.5q1.28-1.5 2.56 0M2.45 10.75 1.5 6.9M17.55 10.75l.95-3.85" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  info: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.5 1.511V.5a.5.5 0 0 0-1 0v.55A2.5 2.5 0 0 0 8 1h-.5V.5a.5.5 0 0 0-1 0V1h-1V.5a.5.5 0 0 0-1 0V1H4a2.5 2.5 0 0 0-.5.05V.5a.5.5 0 0 0-1 0v1.011a2.49 2.49 0 0 0-1 1.989v6A2.503 2.503 0 0 0 4 12h4a2.503 2.503 0 0 0 2.5-2.5v-6a2.49 2.49 0 0 0-1-1.989m0 7.989A1.5 1.5 0 0 1 8 11H4a1.5 1.5 0 0 1-1.5-1.5v-6A1.5 1.5 0 0 1 4 2h4a1.5 1.5 0 0 1 1.5 1.5zM8.5 4a.5.5 0 0 1-.5.5H4a.5.5 0 1 1 0-1h4a.5.5 0 0 1 .5.5m0 2a.5.5 0 0 1-.5.5H4a.5.5 0 1 1 0-1h4a.5.5 0 0 1 .5.5m-2 2a.5.5 0 0 1-.5.5H4a.5.5 0 1 1 0-1h2a.5.5 0 0 1 .5.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  italic: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8" />
      </g>
    ),
    viewBox: { width: 1024, height: 1024 },
    defaultSize: { width: 24, height: 24 },
  },

  lawyer: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12 9.332V9.5a1 1 0 0 1-1.168.986c-.492-.08-.832-.541-.832-1.039v-.115l.427-1.21-.927-.174v3.053h1a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1h1V7.76l-.876-.165.43 1.204v.287h-.006a1.03 1.03 0 0 1-1.233.892C6.33 9.882 6 9.423 6 8.928v-.122l.53-1.69a.83.83 0 0 1 .943-.567l1.027.19V6.5a.5.5 0 1 1 1 0v.426l1.205.224c.338.062.617.299.732.622zM1.5 3c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3m1 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2m2 4A4.505 4.505 0 0 0 0 11.5a.5.5 0 1 0 1 0C1 9.57 2.57 8 4.5 8a.5.5 0 1 0 0-1" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "learning-tab-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16.583 2.576A3.333 3.333 0 0 0 12.417.128l-1.437.41c-.364.105-.7.292-.98.546a2.5 2.5 0 0 0-.98-.545L7.583.128a3.333 3.333 0 0 0-4.162 2.448A4.17 4.17 0 0 0 0 6.667V12.5a4.17 4.17 0 0 0 4.167 4.167h5v1.667h-2.5a.833.833 0 1 0 0 1.666h6.666a.833.833 0 0 0 0-1.666h-2.5v-1.667h5A4.17 4.17 0 0 0 20 12.5V6.667a4.166 4.166 0 0 0-3.417-4.09m-5.75.367a.83.83 0 0 1 .604-.801l1.438-.41A1.667 1.667 0 0 1 15 3.333v3.281a1.67 1.67 0 0 1-1.208 1.601l-2.959.845zM5.667 2a1.66 1.66 0 0 1 1.458-.269l1.438.411a.83.83 0 0 1 .604.8v6.12l-2.959-.846A1.67 1.67 0 0 1 5 6.616V3.333A1.66 1.66 0 0 1 5.667 2m12.666 10.5a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V6.667A2.5 2.5 0 0 1 3.333 4.32v2.295A3.345 3.345 0 0 0 5.75 9.82l2.876.822a5 5 0 0 0 2.75 0l2.876-.822a3.345 3.345 0 0 0 2.415-3.205V4.32a2.5 2.5 0 0 1 1.666 2.347z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  learning: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16.583 2.576A3.333 3.333 0 0 0 12.417.128l-1.437.41c-.364.105-.7.292-.98.546a2.5 2.5 0 0 0-.98-.545L7.583.128a3.333 3.333 0 0 0-4.162 2.448A4.17 4.17 0 0 0 0 6.667V12.5a4.17 4.17 0 0 0 4.167 4.167h5v1.667h-2.5a.833.833 0 1 0 0 1.666h6.666a.833.833 0 0 0 0-1.666h-2.5v-1.667h5A4.17 4.17 0 0 0 20 12.5V6.667a4.166 4.166 0 0 0-3.417-4.09m-5.75.367a.83.83 0 0 1 .604-.801l1.438-.41A1.667 1.667 0 0 1 15 3.333v3.281a1.67 1.67 0 0 1-1.208 1.601l-2.959.845zM5.667 2a1.66 1.66 0 0 1 1.458-.269l1.438.411a.83.83 0 0 1 .604.8v6.12l-2.959-.846A1.67 1.67 0 0 1 5 6.616V3.333A1.66 1.66 0 0 1 5.667 2m12.666 10.5a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V6.667A2.5 2.5 0 0 1 3.333 4.32v2.295A3.345 3.345 0 0 0 5.75 9.82l2.876.822a5 5 0 0 0 2.75 0l2.876-.822a3.345 3.345 0 0 0 2.415-3.205V4.32a2.5 2.5 0 0 1 1.666 2.347z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "left-arrow": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m11.075 15.492-4.65-4.659a.834.834 0 0 1 0-1.175L11.075 5a.834.834 0 0 1 1.425.592V14.9a.833.833 0 0 1-1.425.592" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // Pixel-identical to `arrow-left`, which paints a hard-coded gray-900 and so
  // cannot be tinted or follow the dark theme. Kept as the mono spelling until
  // `arrow-left` gets its currentColor back, at which point the two merge.
  "left-chevron": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m12 6-4 4 4 4" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "left-sidebar-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 1.667H4.167A4.17 4.17 0 0 0 0 5.833v8.334a4.17 4.17 0 0 0 4.167 4.166h11.666A4.17 4.17 0 0 0 20 14.167V5.833a4.17 4.17 0 0 0-4.167-4.166m-14.166 12.5V5.833c0-1.378 1.121-2.5 2.5-2.5H7.5v13.334H4.167a2.503 2.503 0 0 1-2.5-2.5m16.666 0c0 1.378-1.121 2.5-2.5 2.5H9.167V3.332h6.666c1.379 0 2.5 1.122 2.5 2.5zm-12.5-5c0 .46-.372.833-.833.833h-.833a.833.833 0 1 1 0-1.667H5c.46 0 .833.373.833.833m0 3.333c0 .46-.372.833-.833.833h-.833a.833.833 0 1 1 0-1.667H5c.46 0 .833.373.833.834m-2.5-6.667c0-.46.373-.833.834-.833H5a.833.833 0 1 1 0 1.667h-.833a.833.833 0 0 1-.834-.834" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // The design system draws up-arrow and down-arrow only (its left-arrow and
  // right-arrow are carets). This is up-arrow turned a quarter, so the four
  // read as one set; replace it when the designer draws one.
  "leftward-arrow": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M8.234 5.242 4.659 8.825a1.667 1.667 0 0 0 0 2.35l3.575 3.584a.833.833 0 1 0 1.175-1.184l-2.742-2.741h9.167a.833.833 0 0 0 0-1.667H6.667l2.742-2.742a.834.834 0 0 0-1.175-1.183" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "legend-list": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M3.5 3h8a.5.5 0 0 0 0-1h-8a.5.5 0 0 0 0 1M11.5 5.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1M11.5 9h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1M1 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M1 10.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  lightbulb: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M7.91 2.668c-2.79.045-5.14 2.35-5.24 5.136a5.3 5.3 0 0 0 1.834 4.217c.527.458.83 1.162.83 1.98 0 1.102.897 2 2 2h1.333c1.102 0 2-.898 2-2v-.25c0-.645.303-1.266.854-1.751a5.32 5.32 0 0 0 1.813-4c0-1.44-.566-2.791-1.594-3.802a5.26 5.26 0 0 0-3.83-1.53M9.332 14a.667.667 0 0 1-.666.667H7.333c-.368 0-.666-.299-.666-.713 0-.21-.02-.417-.052-.62h2.746a4 4 0 0 0-.028.416zm1.309-3.002c-.341.3-.616.638-.827 1.002H8.667V9.21A2 2 0 0 0 10 7.334a.666.666 0 1 0-1.333 0 .666.666 0 1 1-1.334 0 .666.666 0 1 0-1.333 0c0 .868.56 1.602 1.333 1.878V12H6.17a3.6 3.6 0 0 0-.792-.986 3.98 3.98 0 0 1-1.374-3.163c.074-2.09 1.837-3.817 3.93-3.851H8c1.057 0 2.052.406 2.806 1.148a3.994 3.994 0 0 1-.163 5.85zm.548-9.348.824-1.34a.665.665 0 1 1 1.135.698l-.823 1.34a.665.665 0 0 1-.917.219.666.666 0 0 1-.219-.918m4.419 2.765-1.289.581a.666.666 0 1 1-.548-1.215l1.289-.58a.664.664 0 0 1 .881.333.665.665 0 0 1-.333.88M2.796 1.007A.666.666 0 1 1 3.933.31l.821 1.34a.666.666 0 1 1-1.137.697zm-.322 3.7a.665.665 0 0 1-.889.313L.387 4.446a.666.666 0 1 1 .575-1.202l1.199.574a.667.667 0 0 1 .313.89" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "link-out": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10 5.5v4c0 1.379-1.121 2.5-2.5 2.5h-5A2.503 2.503 0 0 1 0 9.5v-5C0 3.122 1.122 2 2.5 2h4a.5.5 0 0 1 0 1h-4C1.673 3 1 3.673 1 4.5v5c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5v-4a.5.5 0 0 1 1 0m.5-5.5H7a.5.5 0 0 0 0 1h3.293L4.147 7.147a.5.5 0 1 0 .707.707L11 1.707V5a.5.5 0 0 0 1 0V1.5c0-.827-.673-1.5-1.5-1.5" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  link: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="m11.537 14.39-2.718 2.718a4.19 4.19 0 0 1-5.926-5.924L5.61 8.463a.833.833 0 1 0-1.18-1.178l-2.717 2.72A5.857 5.857 0 1 0 10 18.286l2.719-2.718a.833.833 0 0 0-1.179-1.178zM18.286 1.718A5.82 5.82 0 0 0 14.146 0a5.82 5.82 0 0 0-4.14 1.714l-2.723 2.72A.834.834 0 1 0 8.46 5.612l2.721-2.719a4.16 4.16 0 0 1 2.962-1.227 4.19 4.19 0 0 1 2.961 7.152l-2.718 2.718a.834.834 0 0 0 1.18 1.18L18.284 10a5.864 5.864 0 0 0 .001-8.282" />
        <path d="m11.91 6.911-5 5a.832.832 0 1 0 1.178 1.178l5-5a.833.833 0 0 0-1.178-1.178" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  "list-bullet": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round">
        <path d="M6.5 4H14M6.5 8H14m-7.5 4H14" />
        <circle cx="3" cy="4" r="1" fill="var(--icon-fill, currentColor)" stroke="none" />
        <circle cx="3" cy="8" r="1" fill="var(--icon-fill, currentColor)" stroke="none" />
        <circle cx="3" cy="12" r="1" fill="var(--icon-fill, currentColor)" stroke="none" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "list-numbered": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.5 4H14M6.5 8H14m-7.5 4H14" />
        <path strokeWidth="1" d="m2.5 2.75.75-.5v3M2.25 7h1.5v1l-1.5 1v.5h1.5M2.25 11h1.5v1.1h-1m1 0v1.4h-1.5" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "location-icon": {
    path: (
      <g>
        <path fill="var(--icon-fill, currentColor)" d="M12.885 8.333h-.416v-.416c0-1.15-.935-2.084-2.084-2.084h-.833A2.086 2.086 0 0 0 7.47 7.917v.416h-.417a2.086 2.086 0 0 0-2.083 2.083v.834c0 1.149.935 2.083 2.083 2.083h.417v.417c0 1.149.935 2.083 2.083 2.083h.833a2.086 2.086 0 0 0 2.084-2.083v-.417h.416a2.086 2.086 0 0 0 2.084-2.083v-.834c0-1.149-.935-2.083-2.084-2.083m.417 2.917c0 .229-.187.416-.417.416h-1.25a.833.833 0 0 0-.833.834v1.25c0 .229-.187.416-.417.416h-.833a.417.417 0 0 1-.417-.416V12.5a.833.833 0 0 0-.833-.834h-1.25a.417.417 0 0 1-.417-.416v-.834c0-.229.187-.416.417-.416h1.25c.46 0 .833-.373.833-.833v-1.25c0-.23.187-.417.417-.417h.833c.23 0 .417.187.417.417v1.25c0 .46.373.833.833.833h1.25c.23 0 .417.187.417.416zm4.83-6.601L12.3.712a4.15 4.15 0 0 0-4.662 0L1.805 4.65A4.16 4.16 0 0 0-.03 8.103v7.73A4.17 4.17 0 0 0 4.135 20h11.667a4.17 4.17 0 0 0 4.167-4.167v-7.73a4.16 4.16 0 0 0-1.836-3.454m.17 11.184c0 1.379-1.122 2.5-2.5 2.5H4.135a2.503 2.503 0 0 1-2.5-2.5v-7.73c0-.832.412-1.606 1.102-2.071l5.834-3.937a2.49 2.49 0 0 1 2.797 0L17.2 6.032a2.5 2.5 0 0 1 1.102 2.071z" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  measure: {
    path: (
      <>
        <g clipPath="url(#measure_a)">
          <path fill="var(--icon-fill, currentColor)" d="M11.912 8.59 3.911.587A1.96 1.96 0 0 0 1.734.155 1.965 1.965 0 0 0 .5 2.001v7.495A2.506 2.506 0 0 0 3.004 12h7.495c.823 0 1.53-.473 1.845-1.234a1.97 1.97 0 0 0-.432-2.177m-.49 1.794a.97.97 0 0 1-.923.616H3.003A1.505 1.505 0 0 1 1.5 9.496V2.001a.97.97 0 0 1 .616-.922q.196-.08.393-.08c.255 0 .5.1.695.296l.805.806-.954.954a.5.5 0 1 0 .707.707l.954-.954.733.733-.954.954a.5.5 0 1 0 .707.707l.954-.954.708.707-.954.954a.5.5 0 1 0 .707.707l.954-.954.707.707-.955.954a.5.5 0 1 0 .707.707l.955-.954.707.707-.954.954a.5.5 0 1 0 .707.707l.954-.954.805.805a.97.97 0 0 1 .216 1.088zM5.854 8.146A.5.5 0 0 1 5.5 9H4a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .854-.354z" />
        </g>
        <defs>
          <clipPath id="measure_a">
            <path fill="#fff" d="M.5 0h12v12H.5z" />
          </clipPath>
        </defs>
      </>
    ),
    viewBox: { width: 13, height: 12 },
  },

  // Two branches folding into one — the Patient-history "Merge" action, which
  // reconciles the populated sources into a single value per field. The source
  // artwork ships a clipPath to a 16x16 rect; that is exactly the viewBox, so
  // it is dropped rather than carried in as a DOM id that would collide
  // wherever two icons render at once.
  merge: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16 2.667A2.67 2.67 0 0 0 13.333 0a2.67 2.67 0 0 0-2.666 2.667c0 1.24.851 2.285 2 2.582v.084c0 1.103-.898 2-2 2H10a2.66 2.66 0 0 0-2 .905 2.66 2.66 0 0 0-2-.905h-.667c-1.102 0-2-.897-2-2V5.25a2.67 2.67 0 0 0 2-2.582A2.67 2.67 0 0 0 2.667 0 2.67 2.67 0 0 0 0 2.667c0 1.24.851 2.285 2 2.582v.084a3.337 3.337 0 0 0 3.333 3.334H6c.735 0 1.333.598 1.333 1.333v.751a2.67 2.67 0 0 0-2 2.582A2.67 2.67 0 0 0 8 16a2.67 2.67 0 0 0 2.667-2.667c0-1.24-.852-2.285-2-2.582V10c0-.735.598-1.333 1.333-1.333h.667A3.337 3.337 0 0 0 14 5.333V5.25a2.67 2.67 0 0 0 2-2.582m-14.667 0a1.335 1.335 0 0 1 2.667 0C4 3.402 3.402 4 2.667 4a1.335 1.335 0 0 1-1.334-1.333m8 10.666c0 .736-.598 1.334-1.333 1.334a1.335 1.335 0 0 1-1.333-1.334C6.667 12.598 7.265 12 8 12s1.333.598 1.333 1.333m4-9.333A1.335 1.335 0 0 1 12 2.667c0-.736.598-1.334 1.333-1.334a1.335 1.335 0 0 1 0 2.667" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Line-weight twin of `microphone`, for the exam dictation launcher: it sits
  // beside the Indy launcher's hand-drawn glasses, and the filled `microphone`
  // reads far heavier there. Same drawing — capsule with grille ticks from
  // both edges, cradle hugging the base, no stem. `fill="none"` is
  // load-bearing: the capsule is closed, so a CSS `fill: currentColor` would
  // ink it solid.
  "microphone-outline": {
    path: (
      <g fill="none" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
        <rect width="9" height="13" x="5.5" y="1.25" rx="4.5" />
        <path d="M5.5 6H8m4 0h2.5m-9 3H8m4 0h2.5M1.75 9.75a8.25 8.25 0 0 0 16.5 0" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  microphone: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M8 13.333A5.34 5.34 0 0 0 13.333 8V5.333a5.333 5.333 0 1 0-10.666 0V8A5.34 5.34 0 0 0 8 13.333m0-12a4.004 4.004 0 0 1 3.94 3.334H10A.667.667 0 1 0 10 6h2v1.333h-2a.667.667 0 1 0 0 1.334h1.94a3.996 3.996 0 0 1-7.88 0H6a.667.667 0 1 0 0-1.334H4V6h2a.667.667 0 0 0 0-1.333H4.06A4.004 4.004 0 0 1 8 1.333" />
        <path d="M15.333 8a.667.667 0 0 0-.666.667 6.007 6.007 0 0 1-6 6H7.333a6.01 6.01 0 0 1-6-6 .667.667 0 1 0-1.333 0A7.34 7.34 0 0 0 7.333 16h1.334A7.34 7.34 0 0 0 16 8.667.666.666 0 0 0 15.333 8" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  more: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M4 9.334q-.55 0-.942-.392A1.28 1.28 0 0 1 2.667 8q0-.55.391-.941.392-.392.942-.392t.941.392q.393.391.392.941 0 .55-.392.942A1.28 1.28 0 0 1 4 9.334m4 0q-.55 0-.942-.392A1.28 1.28 0 0 1 6.667 8q0-.55.391-.941.391-.392.942-.392t.941.392q.393.391.392.941 0 .55-.392.942A1.28 1.28 0 0 1 8 9.334m4 0q-.55 0-.942-.392A1.28 1.28 0 0 1 10.666 8q0-.55.392-.941.391-.392.942-.392t.941.392q.393.391.392.941 0 .55-.392.942a1.28 1.28 0 0 1-.941.392" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "no-record": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M2.5 3.524V9.5A1.5 1.5 0 0 0 4 11h4a1.5 1.5 0 0 0 1.06-.44q.122-.121.21-.266l.718.718q-.101.135-.221.255A2.5 2.5 0 0 1 8 12H4a2.504 2.504 0 0 1-2.5-2.5v-6c0-.284.05-.565.145-.831z" />
        <path fillRule="evenodd" d="M9 0a.5.5 0 0 1 .5.5V1.51a2.49 2.49 0 0 1 1 1.989v6q0 .17-.025.34l1.243 1.242a.45.45 0 0 1-.636.636L.282.918A.45.45 0 1 1 .918.282l1.39 1.39q.091-.085.192-.16V.5a.5.5 0 0 1 1 0v.55Q3.747 1 4 1h.5V.5a.5.5 0 0 1 1 0V1h1V.5a.5.5 0 0 1 1 0V1H8q.253 0 .5.05V.5A.5.5 0 0 1 9 0M4 2a1.5 1.5 0 0 0-.99.374L4.137 3.5H8a.5.5 0 0 1 0 1H5.136l1 1H8a.5.5 0 0 1 0 1h-.864L9.5 8.863V3.5A1.5 1.5 0 0 0 8 2z" clipRule="evenodd" />
        <path d="M6 7.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1zM5.476 6.5H4a.5.5 0 0 1 0-1h.476z" />
      </g>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "no-show": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M6 0C2.692 0 0 2.692 0 6c0 3.309 2.692 6 6 6 3.309 0 6-2.691 6-6 0-3.308-2.691-6-6-6m0 11c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m3.354-6.646L8.707 5l.646.646a.5.5 0 1 1-.707.708L8 5.707l-.646.647a.5.5 0 0 1-.708 0 .5.5 0 0 1 0-.708L7.294 5l-.647-.646a.5.5 0 1 1 .708-.707L8 4.293l.646-.647a.5.5 0 1 1 .707.708M4 5.707l-.647.647a.5.5 0 0 1-.707 0 .5.5 0 0 1 0-.708L3.294 5l-.647-.646a.5.5 0 1 1 .708-.707L4 4.293l.646-.647a.5.5 0 1 1 .708.708L4.707 5l.647.646a.5.5 0 1 1-.708.708zm3.482 2.905c.065.191-.087.387-.288.387H4.8c-.202 0-.353-.198-.287-.39C4.701 8.074 5.28 7.5 6 7.5c.72 0 1.3.576 1.482 1.113" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  note: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10 1.511V.5a.5.5 0 0 0-1 0v.55A2.5 2.5 0 0 0 8.5 1H8V.5a.5.5 0 0 0-1 0V1H6V.5a.5.5 0 0 0-1 0v1.011c-2.31.231-2.561.531-2.735.876A2.5 2.5 0 0 0 2 3.5v6A2.503 2.503 0 0 0 4.5 12h4A2.503 2.503 0 0 0 11 9.5v-6a2.49 2.49 0 0 0-1-1.989M10 9.5A1.5 1.5 0 0 1 8.5 11h-4A1.5 1.5 0 0 1 3 9.5v-6A1.5 1.5 0 0 1 4.5 2h4A1.5 1.5 0 0 1 10 3.5zM9 4a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h4A.5.5 0 0 1 9 4m0 2a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h4A.5.5 0 0 1 9 6M7 8a.5.5 0 0 1-.5.5h-2a.5.5 0 1 1 0-1h2A.5.5 0 0 1 7 8" />
    ),
    viewBox: { width: 13, height: 12 },
  },

  notification: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="m11.278 6.831-.95-3.418a4.66 4.66 0 0 0-9.04.237L.553 6.958A2.5 2.5 0 0 0 2.993 10h.557a2.5 2.5 0 0 0 4.9 0h.42a2.5 2.5 0 0 0 2.408-3.169M6 11.001a1.5 1.5 0 0 1-1.408-1h2.816A1.5 1.5 0 0 1 6 11m4.063-2.593A1.49 1.49 0 0 1 8.87 9H2.993A1.5 1.5 0 0 1 1.53 7.175l.735-3.308a3.66 3.66 0 0 1 7.1-.186l.95 3.418a1.49 1.49 0 0 1-.25 1.309" />
        <circle cx="10" cy="2" r="2.5" fill="var(--icon-fill, currentColor)" stroke="var(--indigo-gray-0, #ffffff)" strokeWidth="1" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "notifications-tab": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m18.797 11.385-1.584-5.697a7.768 7.768 0 0 0-15.066.395L.922 11.596a4.167 4.167 0 0 0 4.067 5.07h.928a4.167 4.167 0 0 0 8.167 0h.698a4.165 4.165 0 0 0 4.015-5.28M10 18.333a2.5 2.5 0 0 1-2.347-1.666h4.693a2.5 2.5 0 0 1-2.346 1.666m6.771-4.32a2.48 2.48 0 0 1-1.99.987H4.989a2.5 2.5 0 0 1-2.44-3.042l1.225-5.514a6.1 6.1 0 0 1 11.833-.31l1.584 5.697a2.48 2.48 0 0 1-.419 2.182" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  outdent: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7.5 4H14M7.5 8H14m-6.5 4H14M4.5 5.5 2 8l2.5 2.5" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "paid-case": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12 3.5v6.063a2.5 2.5 0 0 1-1.876 2.421.5.5 0 0 1-.249-.968A1.5 1.5 0 0 0 11 9.563V5H9.5a.5.5 0 1 1 0-1H11v-.5c0-.827-.673-1.5-1.5-1.5h-7C1.673 2 1 2.673 1 3.5V4h1.5a.5.5 0 0 1 0 1H1v4.563a1.5 1.5 0 0 0 1.124 1.453.5.5 0 1 1-.249.968A2.5 2.5 0 0 1 0 9.563V3.5C0 2.122 1.122 1 2.5 1H3V.5a.5.5 0 0 1 1 0V1h4V.5a.5.5 0 1 1 1 0V1h.5C10.879 1 12 2.122 12 3.5M9.75 8.25a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0M8 9.188c0-.644-.461-1.189-1.096-1.294L5.26 7.62A.312.312 0 0 1 5.312 7h1.322c.178 0 .344.096.433.25a.499.499 0 1 0 .865-.5A1.5 1.5 0 0 0 6.634 6H6.5a.5.5 0 0 0-1 0H5.31C4.589 6 4 6.588 4 7.31c0 .644.46 1.189 1.096 1.294l1.643.274a.312.312 0 0 1-.051.62H5.364a.5.5 0 0 1-.434-.25.499.499 0 1 0-.865.501c.268.463.765.75 1.299.75h.134a.5.5 0 0 0 1 0h.188c.723 0 1.312-.589 1.312-1.312z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  partial: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M1.21 3.245a.5.5 0 0 1-.12-.695c.4-.565.89-1.055 1.455-1.455a.497.497 0 0 1 .695.12c.16.225.105.54-.12.695-.47.335-.88.74-1.215 1.215a.49.49 0 0 1-.41.21c-.1 0-.2-.03-.29-.09zm.7 5.63a.498.498 0 1 0-.815.575c.4.565.89 1.055 1.455 1.455a.51.51 0 0 0 .7-.12.497.497 0 0 0-.12-.695 5 5 0 0 1-1.215-1.215zM1 6c0-.305.025-.61.08-.905a.499.499 0 0 0-.98-.18C.035 5.27 0 5.635 0 6s.035.73.1 1.085c.045.24.255.41.49.41.03 0 .06 0 .09-.01.27-.05.45-.31.4-.58C1.025 6.61 1 6.305 1 6m9.09 2.875q-.503.712-1.215 1.215a.498.498 0 0 0 .29.905c.1 0 .2-.03.29-.09.565-.4 1.055-.89 1.455-1.455a.497.497 0 0 0-.12-.695.497.497 0 0 0-.695.12zM6.905 10.92c-.295.055-.6.08-.905.08s-.61-.025-.905-.08a.499.499 0 0 0-.18.98c.355.065.72.1 1.085.1s.73-.035 1.085-.1a.499.499 0 0 0-.18-.98M7.085.1A6 6 0 0 0 6 0c-.365 0-.73.035-1.085.1a.499.499 0 0 0 .09.99c.03 0 .06 0 .09-.01.295-.055.6-.08.905-.08s.61.025.905.08q.045.009.09.01a.499.499 0 0 0 .09-.99m3.005 3.025c.095.14.25.21.41.21a.498.498 0 0 0 .41-.785 6.1 6.1 0 0 0-1.455-1.455.497.497 0 0 0-.695.12.497.497 0 0 0 .12.695q.713.502 1.215 1.215zm1.81 1.79a.499.499 0 0 0-.98.18c.055.295.08.6.08.905s-.025.61-.08.905a.499.499 0 0 0 .98.18c.065-.355.1-.72.1-1.085s-.035-.73-.1-1.085" />
    ),
    viewBox: { width: 12, height: 12 },
    defaultSize: { width: 16, height: 16 },
  },

  "past-cases-tab": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.823 1.645h-5.44a.85.85 0 0 1-.373-.087L7.38.242A2.5 2.5 0 0 0 6.262-.02H4.156A4.17 4.17 0 0 0-.011 4.145v10c0 1.483.799 2.865 2.083 3.609a.832.832 0 1 0 .835-1.442 2.51 2.51 0 0 1-1.251-2.167v-7.5h16.667v7.5c0 .89-.48 1.72-1.251 2.167a.832.832 0 0 0 .418 1.554.8.8 0 0 0 .417-.112 4.18 4.18 0 0 0 2.082-3.609V5.812a4.17 4.17 0 0 0-4.166-4.167m-14.167 2.5c0-1.378 1.122-2.5 2.5-2.5h2.106c.128 0 .258.03.372.088l2.63 1.316c.346.171.733.262 1.118.262h5.44c1.085 0 2.001.7 2.346 1.667H1.656zm8.326 4.167a5.84 5.84 0 0 0-5.834 5.833 5.84 5.84 0 0 0 5.834 5.834 5.84 5.84 0 0 0 5.833-5.834 5.84 5.84 0 0 0-5.833-5.833m0 10a4.17 4.17 0 0 1-4.167-4.167A4.17 4.17 0 0 1 9.982 9.98a4.17 4.17 0 0 1 4.166 4.166 4.17 4.17 0 0 1-4.166 4.167m1.422-3.922a.832.832 0 1 1-1.178 1.178l-.833-.833a.83.83 0 0 1-.245-.59V12.48a.833.833 0 1 1 1.667 0V13.8z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  pdf: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m16.624 4.617-2.908-2.909A5.8 5.8 0 0 0 9.591 0H5.833a4.17 4.17 0 0 0-4.167 4.167v11.666c0 2.3 1.867 4.167 4.167 4.167h8.333c2.3 0 4.167-1.867 4.167-4.167V8.742a5.8 5.8 0 0 0-1.709-4.125M15.45 5.792q.4.4.675.875h-3.616a.836.836 0 0 1-.834-.834V2.217q.476.274.875.675L15.458 5.8zm1.217 10.041c0 1.375-1.125 2.5-2.5 2.5H5.833a2.507 2.507 0 0 1-2.5-2.5V4.167c0-1.375 1.125-2.5 2.5-2.5H9.59c.133 0 .275 0 .408.016v4.15c0 1.375 1.125 2.5 2.5 2.5h4.15c.017.134.017.267.017.409zm-10.758-5h-.909a.836.836 0 0 0-.833.834v3.7c0 .291.233.516.517.516a.52.52 0 0 0 .516-.516V14.35h.7c.984 0 1.784-.792 1.784-1.758 0-.967-.8-1.759-1.784-1.759zm-.692 2.475v-1.433h.7c.4 0 .742.325.742.717s-.342.716-.742.716zm10.633-1.95a.514.514 0 0 1-.516.517h-1.409v.95h1.034c.291 0 .516.233.516.517a.52.52 0 0 1-.516.516h-1.034v1.5a.514.514 0 0 1-.516.517.52.52 0 0 1-.517-.517V11.35c0-.292.233-.517.517-.517h1.925c.291 0 .516.234.516.517zm-5.775-.516h-.908a.836.836 0 0 0-.833.833v3.7c0 .292.233.467.516.467h1.217c.983 0 1.783-.792 1.783-1.759V12.6c0-.967-.8-1.758-1.783-1.758zm.742 3.241c0 .392-.342.717-.742.717h-.691v-2.917h.7c.4 0 .741.325.741.717v1.483z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  pencil: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19.044.957a3.02 3.02 0 0 0-4.27 0L1.221 14.51A4.14 4.14 0 0 0 0 17.456v1.71A.833.833 0 0 0 .833 20h1.711a4.14 4.14 0 0 0 2.946-1.22L19.044 5.226a3.02 3.02 0 0 0 0-4.27M4.312 17.602c-.47.466-1.105.73-1.768.731h-.877v-.877a2.48 2.48 0 0 1 .732-1.768L12.685 5.402l1.917 1.917zM17.865 4.047l-2.088 2.09-1.917-1.913 2.09-2.089a1.353 1.353 0 1 1 1.912 1.917z" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  "physician-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M7.5 10c2.758 0 5-2.242 5-5s-2.242-5-5-5-5 2.243-5 5 2.242 5 5 5m0-8.333A3.337 3.337 0 0 1 10.833 5 3.337 3.337 0 0 1 7.5 8.333 3.337 3.337 0 0 1 4.167 5 3.337 3.337 0 0 1 7.5 1.667M8.333 12.5c0 .46-.373.833-.833.833a5.84 5.84 0 0 0-5.833 5.834.834.834 0 0 1-1.667 0c0-4.135 3.365-7.5 7.5-7.5.46 0 .833.373.833.833m9.167-.79v-.043c0-.92-.747-1.667-1.667-1.667h-1.666c-.92 0-1.667.748-1.667 1.667v.042a2.91 2.91 0 0 0-2.5 2.874v2.5A2.92 2.92 0 0 0 12.917 20h4.166A2.92 2.92 0 0 0 20 17.083v-2.5c0-1.465-1.09-2.67-2.5-2.874m-4.583 1.623h4.166c.69 0 1.25.561 1.25 1.25V15h-6.666v-.417c0-.689.56-1.25 1.25-1.25m4.166 5h-4.166c-.69 0-1.25-.56-1.25-1.25v-.416h2.5a.834.834 0 0 0 1.666 0h2.5v.416c0 .69-.56 1.25-1.25 1.25" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  play: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m16.395 10.122-5.192-2.843a2.13 2.13 0 0 0-2.138.017 2.13 2.13 0 0 0-1.064 1.855v5.699c0 .772.397 1.465 1.064 1.855a2.118 2.118 0 0 0 2.128.023l5.212-2.854a2.12 2.12 0 0 0 1.096-1.873c0-.787-.409-1.487-1.105-1.878zm-.961 2.003-5.212 2.855c-.019.01-.077.042-.147-.001-.074-.043-.074-.107-.074-.128V9.152c0-.021 0-.085.074-.128a.14.14 0 0 1 .074-.021.2.2 0 0 1 .083.026l5.192 2.844c.019.011.076.043.076.13s-.058.119-.066.125zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10" />
    ),
    viewBox: { width: 24, height: 24 },
    defaultSize: { width: 20, height: 20 },
  },

  "popup-window": {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M3.2 8.5a.7.7 0 0 1 .7.7v1.3h1.3a.7.7 0 1 1 0 1.4h-2a.7.7 0 0 1-.7-.7v-2a.7.7 0 0 1 .7-.7M12.8 4.1a.7.7 0 0 1 .7.7v2a.7.7 0 1 1-1.4 0V5.5h-1.3a.7.7 0 1 1 0-1.4z" />
        <path fill="var(--icon-fill, currentColor)" fillRule="evenodd" d="M12.8 1.6A3.2 3.2 0 0 1 16 4.8v6.4l-.004.165a3.2 3.2 0 0 1-3.031 3.031l-.165.004H3.2l-.165-.004A3.2 3.2 0 0 1 0 11.2V4.8a3.2 3.2 0 0 1 3.2-3.2zM3.2 3a1.8 1.8 0 0 0-1.8 1.8v6.4A1.8 1.8 0 0 0 3.2 13h9.6a1.8 1.8 0 0 0 1.8-1.8V4.8A1.8 1.8 0 0 0 12.8 3z" clipRule="evenodd" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  power: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M12.5 3.207a.85.85 0 0 0 .525.772 7.5 7.5 0 0 1 4.475 7.097 7.501 7.501 0 0 1-15-.243A7.5 7.5 0 0 1 6.976 3.98a.85.85 0 0 0 .524-.774.833.833 0 0 0-1.145-.774 9.167 9.167 0 1 0 7.293 0 .833.833 0 0 0-1.148.775" />
        <path fill="var(--icon-fill, currentColor)" d="M10.833.833a.833.833 0 1 0-1.666 0v5a.833.833 0 1 0 1.666 0z" />
      </>
    ),
    viewBox: { width: 20, height: 20 },
  },

  preferences: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M11.5 2h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1M5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M.5 2a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zm11 5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1M10 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M.5 7a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zm11 5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1M5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M.5 12a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z" />
    ),
    viewBox: { width: 12, height: 13 },
  },

  "previsit-appointments-tab-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833.833H4.167A4.17 4.17 0 0 0 0 5v10a4.17 4.17 0 0 0 4.167 4.167h11.666A4.17 4.17 0 0 0 20 15V5A4.17 4.17 0 0 0 15.833.833M18.333 15c0 1.378-1.121 2.5-2.5 2.5H4.167a2.503 2.503 0 0 1-2.5-2.5V5c0-1.378 1.121-2.5 2.5-2.5h11.666c1.379 0 2.5 1.122 2.5 2.5zm-2.5-9.167c0 .46-.373.834-.833.834H9.167a.834.834 0 0 1 0-1.667H15c.46 0 .833.373.833.833m-9.166 0a1.25 1.25 0 1 1-2.501 0 1.25 1.25 0 0 1 2.5 0M15.833 10c0 .46-.373.833-.833.833H9.167a.834.834 0 0 1 0-1.666H15c.46 0 .833.373.833.833m-9.166 0a1.25 1.25 0 1 1-2.501 0 1.25 1.25 0 0 1 2.5 0m9.166 4.167c0 .46-.373.833-.833.833H9.167a.834.834 0 0 1 0-1.667H15c.46 0 .833.374.833.834m-9.166 0a1.25 1.25 0 1 1-2.501-.001 1.25 1.25 0 0 1 2.5 0" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // A static 12-dot ring. The registry's `spinner` is a two-tone arc that
  // animates, and `assets/icons/spinner.svg` is a third drawing again (21.9%
  // apart) — neither is right for a dropdown-menu status glyph. Re-gridded
  // from 16 in a 20 box to 16x16: the legacy source drew it at 80% pinned to
  // the top-left corner of its frame, which is why it does not raster-match
  // its original.
  processing: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M8.667.667V2a.667.667 0 0 1-1.334 0V.667a.667.667 0 0 1 1.334 0M8 13.333a.667.667 0 0 0-.667.667v1.333a.667.667 0 1 0 1.334 0V14A.667.667 0 0 0 8 13.333M2.667 8A.667.667 0 0 0 2 7.333H.667a.667.667 0 0 0 0 1.334H2A.667.667 0 0 0 2.667 8m12.666-.667H14a.667.667 0 1 0 0 1.334h1.333a.667.667 0 1 0 0-1.334M12.012 1.08a.667.667 0 0 0-.911.242l-.667 1.154a.667.667 0 0 0 1.154.668l.667-1.154a.667.667 0 0 0-.243-.91M5.325 12.614a.667.667 0 0 0-.911.243l-.667 1.154a.667.667 0 1 0 1.154.667l.667-1.154a.667.667 0 0 0-.243-.91m-2.182-8.2L1.99 3.747a.667.667 0 0 0-.666 1.154l1.154.667a.667.667 0 0 0 .666-1.154m11.534 6.687-1.154-.667a.667.667 0 0 0-.667 1.154l1.154.667a.66.66 0 0 0 .74-.048.667.667 0 0 0-.073-1.106M4.899 1.32a.667.667 0 0 0-1.154.667l.667 1.154a.667.667 0 1 0 1.154-.667zm6.687 11.534a.667.667 0 0 0-1.154.666l.667 1.154a.667.667 0 0 0 1.154-.666zm1.605-7.2c.117 0 .232-.031.334-.09l1.154-.666a.666.666 0 0 0-.667-1.154l-1.154.666a.666.666 0 0 0 .333 1.244M2.475 10.432l-1.154.667a.666.666 0 1 0 .667 1.154l1.154-.667a.667.667 0 0 0-.667-1.154" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  // The 20-grid publish glyph. Same drawing as `publish`, which is drawn on a
  // 14 grid with lighter strokes; at the same rendered size the two are
  // visibly different weights, so both are kept until a designer picks one.
  "publish-bold": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M14.167 15.833C14.167 18.133 12.3 20 10 20H4.167A4.17 4.17 0 0 1 0 15.833V10c0-2.3 1.867-4.167 4.167-4.167H5c.458 0 .833.375.833.833A.836.836 0 0 1 5 7.5h-.833a2.507 2.507 0 0 0-2.5 2.5v5.833c0 1.375 1.125 2.5 2.5 2.5H10c1.375 0 2.5-1.125 2.5-2.5 0-.458.375-.833.833-.833.459 0 .834.375.834.833m5.108-10.925L14.767.25a.823.823 0 0 0-1.175-.017.83.83 0 0 0-.017 1.175l4.283 4.417h-7.025A4.17 4.17 0 0 0 6.667 9.99v4.167c0 .458.375.833.833.833a.836.836 0 0 0 .833-.833V9.99c0-1.375 1.125-2.5 2.5-2.5h7.017l-4.283 4.417a.83.83 0 0 0 .6 1.408.86.86 0 0 0 .6-.25l4.5-4.641a2.497 2.497 0 0 0 .008-3.525z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  publish: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.667 10.336a2.5 2.5 0 0 1-2.5 2.5h-3.5a2.5 2.5 0 0 1-2.5-2.5v-3.5a2.5 2.5 0 0 1 2.5-2.5h.5c.275 0 .5.225.5.5s-.225.5-.5.5h-.5c-.825 0-1.5.675-1.5 1.5v3.5c0 .825.675 1.5 1.5 1.5h3.5c.825 0 1.5-.675 1.5-1.5 0-.275.225-.5.5-.5s.5.225.5.5m3.065-6.555L10.027.986a.494.494 0 0 0-.705-.01.5.5 0 0 0-.01.705l2.57 2.65H7.667a2.5 2.5 0 0 0-2.5 2.5v2.5c0 .275.225.5.5.5s.5-.225.5-.5v-2.5c0-.825.675-1.5 1.5-1.5h4.21l-2.57 2.65a.498.498 0 0 0 .36.845c.125 0 .26-.05.36-.15l2.7-2.785a1.5 1.5 0 0 0 .005-2.115z" />
    ),
    viewBox: { width: 14, height: 14 },
  },

  "rating-minus": {
    path: (
      <path fill="var(--icon-fill, currentColor)" fillRule="evenodd" d="M8 1.5H0V0h8z" clipRule="evenodd" />
    ),
    viewBox: { width: 8, height: 2 },
  },

  "rating-plus": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M4.75 3.25H8v1.5H4.75V8h-1.5V4.75H0v-1.5h3.25V0h1.5z" />
    ),
    viewBox: { width: 8, height: 8 },
  },

  redo: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10.013 1.338a8.92 8.92 0 0 1 8.915 8.926 8.91 8.91 0 0 1-3.433 7.036l.837 1.071a.178.178 0 0 1-.14.288l-3.728-.017c-.116 0-.2-.11-.172-.221l.882-3.623a.178.178 0 0 1 .315-.067l.908 1.163q.342-.269.654-.58a7.12 7.12 0 0 0 2.091-5.05 7.112 7.112 0 0 0-2.091-5.05A7.11 7.11 0 0 0 10 3.125a7.113 7.113 0 0 0-5.05 2.092 7.1 7.1 0 0 0-2.091 5.048 7.113 7.113 0 0 0 2.614 5.522.177.177 0 0 1 .027.248l-.88 1.128a.18.18 0 0 1-.254.029 8.91 8.91 0 0 1-3.295-6.927c0-4.935 4.005-8.933 8.942-8.926" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  refresh: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M6 1a5.02 5.02 0 0 1 3.562 1.5H8a.5.5 0 1 0 0 1h2.071a.93.93 0 0 0 .929-.928V.5a.5.5 0 0 0-1 0v1.04A5.99 5.99 0 0 0 .026 5.45a.504.504 0 0 0 .832.426.5.5 0 0 0 .162-.315A5.007 5.007 0 0 1 6 1.001M11.476 6a.49.49 0 0 0-.495.439A4.994 4.994 0 0 1 2.44 9.5H4a.5.5 0 0 0 0-1H1.93A.93.93 0 0 0 1 9.428V11.5a.5.5 0 0 0 1 0v-1.039a5.99 5.99 0 0 0 9.976-3.911.506.506 0 0 0-.5-.55" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  report: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.407 5a.5.5 0 0 0 .484-.624 3.5 3.5 0 0 0-.916-1.609L7.232 1.026A3.48 3.48 0 0 0 4.757 0H2.5A2.503 2.503 0 0 0 0 2.5v7C0 10.879 1.122 12 2.5 12H4a.5.5 0 0 0 0-1H2.5C1.673 11 1 10.327 1 9.5v-7C1 1.673 1.673 1 2.5 1h2.258A3 3 0 0 1 5 1.012V3.5C5 4.327 5.673 5 6.5 5zM6 3.5V1.33q.286.163.525.402l1.742 1.743q.237.237.402.525H6.5a.5.5 0 0 1-.5-.5m5.561 2.44c-.567-.568-1.555-.568-2.121 0L6.086 9.293c-.378.378-.586.88-.586 1.415v.793a.5.5 0 0 0 .5.5h.793c.534 0 1.037-.209 1.414-.586L11.56 8.06c.284-.284.44-.66.44-1.061a1.5 1.5 0 0 0-.439-1.06m-.707 1.414L7.5 10.707a1 1 0 0 1-.707.293H6.5v-.293c0-.267.104-.518.293-.707l3.353-3.354a.51.51 0 0 1 .707 0 .496.496 0 0 1 0 .707" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  // A hooked back-arrow. `undo` and `redo` are circular arrows and read as
  // "step back", not "bring it back". Pixel-identical to the
  // `assets/icons/restore.svg` nothing ever imported, which Phase 4 deleted in
  // favour of this.
  restore: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M19.167 20a.833.833 0 0 1-.833-.834 5.005 5.005 0 0 0-5-5H8.475v1.322a1.667 1.667 0 0 1-2.845 1.178L.731 11.767a2.5 2.5 0 0 1 0-3.535l4.9-4.899a1.667 1.667 0 0 1 2.844 1.178v1.322H12.5a7.51 7.51 0 0 1 7.5 7.5v5.833a.833.833 0 0 1-.833.834M6.81 4.51l-4.9 4.9a.833.833 0 0 0 0 1.178l4.9 4.899v-2.155a.833.833 0 0 1 .833-.833h5.692a6.65 6.65 0 0 1 5 2.261v-1.428A5.84 5.84 0 0 0 12.5 7.5H7.642a.833.833 0 0 1-.833-.834z" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },

  "right-chevron": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m8 14 4-4-4-4" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  right: {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinejoin="round" strokeWidth="2" d="m6 12 4-4-4-4" />
    ),
    viewBox: { width: 16, height: 16 },
    defaultSize: { width: 20, height: 20 },
  },

  // The design system draws up-arrow and down-arrow only (its left-arrow and
  // right-arrow are carets). This is up-arrow turned a quarter, so the four
  // read as one set; replace it when the designer draws one.
  "rightward-arrow": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m11.766 14.758 3.575-3.583a1.667 1.667 0 0 0 0-2.35l-3.575-3.583a.833.833 0 1 0-1.175 1.183l2.742 2.741H4.166a.833.833 0 0 0 0 1.667h9.167l-2.742 2.742a.834.834 0 0 0 1.175 1.183" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "scheduling-party": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15 10c2.758 0 5-2.243 5-5s-2.242-5-5-5-5 2.242-5 5 2.242 5 5 5m0-8.333A3.337 3.337 0 0 1 18.333 5 3.337 3.337 0 0 1 15 8.333 3.337 3.337 0 0 1 11.667 5 3.337 3.337 0 0 1 15 1.667m-.59 3.922A.83.83 0 0 1 14.168 5V3.333a.834.834 0 0 1 1.666 0v1.322l.59.59a.832.832 0 1 1-1.179 1.177zm2.803 6.791a2.583 2.583 0 0 0-3.568.005l-1.22.97c-2.665-1.13-4.562-3.03-5.777-5.788l.966-1.213c.464-.482.72-1.115.72-1.787 0-.673-.254-1.3-.715-1.782 0 0-1.543-2.005-1.569-2.03a2.56 2.56 0 0 0-1.823-.757c-.689 0-1.337.269-1.782.716l-.958.837C.527 2.51 0 3.804 0 5.198 0 11.562 8.438 20 14.802 20a5.13 5.13 0 0 0 3.683-1.527l.76-.875a2.583 2.583 0 0 0 0-3.649 471 471 0 0 0-2.032-1.569m.814 4.08-.76.876c-.641.642-1.516.997-2.464.997-4.991 0-13.135-7.339-13.135-13.136 0-.948.354-1.824.955-2.427l.96-.838a.9.9 0 0 1 .644-.267.9.9 0 0 1 .612.236S6.374 3.896 6.4 3.921a.9.9 0 0 1 .268.645.9.9 0 0 1-.268.645 450 450 0 0 0-1.363 1.704.84.84 0 0 0-.121.83c1.427 3.555 3.9 6.026 7.352 7.343a.84.84 0 0 0 .815-.127s1.682-1.34 1.704-1.362a.91.91 0 0 1 1.291 0c.025.025 2.02 1.56 2.02 1.56.324.358.312.915-.07 1.301" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  search: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m15.805 14.862-3.98-3.98a6.677 6.677 0 1 0-.942.943l3.979 3.98a.666.666 0 0 0 .943-.943M6.667 12a5.333 5.333 0 1 1 0-10.666 5.333 5.333 0 0 1 0 10.666" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "settings-tab": {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M10 6.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666m0 5a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334" />
        <path fill="var(--icon-fill, currentColor)" d="m17.745 11.583-.37-.213a7.6 7.6 0 0 0 0-2.742l.37-.213a2.502 2.502 0 0 0-2.5-4.333l-.37.214A7.5 7.5 0 0 0 12.5 2.928V2.5a2.5 2.5 0 1 0-5 0v.428a7.5 7.5 0 0 0-2.373 1.371l-.373-.216a2.501 2.501 0 1 0-2.5 4.334l.37.213a7.6 7.6 0 0 0 0 2.742l-.37.213a2.501 2.501 0 1 0 2.5 4.333l.371-.214A7.5 7.5 0 0 0 7.5 17.073v.427a2.5 2.5 0 0 0 5 0v-.427a7.5 7.5 0 0 0 2.374-1.372l.372.215a2.501 2.501 0 1 0 2.5-4.334zm-2.123-3.146a5.87 5.87 0 0 1 0 3.125.834.834 0 0 0 .387.944l.903.521a.834.834 0 0 1-.834 1.445l-.904-.524a.83.83 0 0 0-1.013.138 5.8 5.8 0 0 1-2.702 1.562.834.834 0 0 0-.626.808V17.5a.833.833 0 0 1-1.667 0v-1.043a.83.83 0 0 0-.626-.808 5.8 5.8 0 0 1-2.702-1.566.834.834 0 0 0-1.012-.137l-.903.522a.833.833 0 1 1-.834-1.443l.904-.522a.83.83 0 0 0 .386-.944 5.87 5.87 0 0 1 0-3.125.83.83 0 0 0-.387-.94l-.904-.522a.834.834 0 0 1 .834-1.445l.905.524a.83.83 0 0 0 1.011-.134 5.8 5.8 0 0 1 2.703-1.563.83.83 0 0 0 .626-.81V2.5a.833.833 0 1 1 1.667 0v1.043a.83.83 0 0 0 .625.808 5.8 5.8 0 0 1 2.703 1.566.834.834 0 0 0 1.012.137l.904-.522a.833.833 0 1 1 .833 1.443l-.903.522a.83.83 0 0 0-.386.94" />
      </>
    ),
    viewBox: { width: 20, height: 20 },
  },

  settings: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M10 6.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666m0 5a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334" />
        <path fill="var(--icon-fill, currentColor)" d="m17.745 11.583-.37-.213a7.6 7.6 0 0 0 0-2.742l.37-.213a2.502 2.502 0 0 0-2.5-4.333l-.37.214A7.5 7.5 0 0 0 12.5 2.928V2.5a2.5 2.5 0 0 0-5 0v.428a7.5 7.5 0 0 0-2.373 1.371l-.373-.216a2.501 2.501 0 1 0-2.5 4.334l.37.213a7.6 7.6 0 0 0 0 2.742l-.37.213a2.501 2.501 0 1 0 2.5 4.333l.371-.214A7.5 7.5 0 0 0 7.5 17.073v.427a2.5 2.5 0 0 0 5 0v-.427a7.5 7.5 0 0 0 2.373-1.372l.373.215a2.501 2.501 0 1 0 2.5-4.334zm-2.123-3.146a5.87 5.87 0 0 1 0 3.125.83.83 0 0 0 .386.944l.904.521a.834.834 0 0 1-.834 1.445l-.905-.524a.83.83 0 0 0-1.012.138 5.8 5.8 0 0 1-2.703 1.562.83.83 0 0 0-.626.808V17.5a.833.833 0 0 1-1.666 0v-1.043a.83.83 0 0 0-.626-.808 5.8 5.8 0 0 1-2.702-1.566.834.834 0 0 0-1.012-.137l-.903.522a.833.833 0 1 1-.834-1.443l.904-.522a.83.83 0 0 0 .386-.944 5.87 5.87 0 0 1 0-3.125.83.83 0 0 0-.387-.94l-.904-.522c-.091-.11-.23-.293-.288-.506a.834.834 0 0 1 1.222-.939l.905.524a.83.83 0 0 0 1.011-.134 5.8 5.8 0 0 1 2.703-1.563.83.83 0 0 0 .626-.81V2.5c0-.221.087-.433.244-.59.056-.156.268-.243.489-.243a.833.833 0 0 1 .833.833v1.043a.83.83 0 0 0 .626.808 5.8 5.8 0 0 1 2.703 1.566.83.83 0 0 0 1.012.137l.904-.522a.833.833 0 1 1 .833 1.443l-.904.522a.83.83 0 0 0-.385.94" />
      </>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  shield: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M8.287 1.063 5.169.03A.6.6 0 0 0 5 0a.5.5 0 0 0-.17.03L1.713 1.063A2.5 2.5 0 0 0 0 3.436v2.585c0 3.282 3.503 5.289 4.576 5.826l.201.1a.5.5 0 0 0 .41.017l.209-.085c1.08-.434 4.603-2.14 4.603-5.858V3.436c0-1.08-.688-2.033-1.713-2.373M1 6.022V3.436c0-.647.413-1.22 1.028-1.424l2.472-.82v9.479C3.259 9.958 1 8.34 1 6.02m8 0c0 2.676-2.282 4.133-3.5 4.72v-9.55l2.472.82A1.5 1.5 0 0 1 9 3.436z" />
    ),
    viewBox: { width: 10, height: 12 },
  },

  "sidebar-right": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12.667 1.333H3.333A3.337 3.337 0 0 0 0 4.667v6.666a3.337 3.337 0 0 0 3.333 3.334h9.334A3.337 3.337 0 0 0 16 11.333V4.667a3.337 3.337 0 0 0-3.333-3.334m-11.334 10V4.667c0-1.103.898-2 2-2h5.334v10.666H3.333c-1.102 0-2-.897-2-2m13.334 0c0 1.103-.898 2-2 2H10V2.667h2.667c1.102 0 2 .897 2 2zm-1.334-4a.666.666 0 0 1-.666.667H12a.667.667 0 1 1 0-1.333h.667c.368 0 .666.298.666.666m0 2.667a.666.666 0 0 1-.666.667H12a.667.667 0 1 1 0-1.334h.667c.368 0 .666.298.666.667m0-5.333a.666.666 0 0 1-.666.666H12A.667.667 0 1 1 12 4h.667c.368 0 .666.298.666.667" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  "sign-pen-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19.757 6.078a.83.83 0 0 0-1.179 0l-1.91 1.91-4.656-4.654 1.911-1.911A.832.832 0 1 0 12.745.244l-2.37 2.371-4.887 1.808a4.18 4.18 0 0 0-2.56 2.764L.092 17.12a2.24 2.24 0 0 0 .567 2.22 2.24 2.24 0 0 0 2.212.568l9.904-2.814a4.18 4.18 0 0 0 2.762-2.545l1.846-4.922 2.372-2.372a.83.83 0 0 0 0-1.178m-5.78 7.887a2.51 2.51 0 0 1-1.657 1.528l-9.267 2.633 4.849-4.848q.207.055.431.056a1.666 1.666 0 1 0-1.61-1.235l-4.847 4.848 2.653-9.301a2.51 2.51 0 0 1 1.537-1.66l4.556-1.685 5.075 5.076z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  sign: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12.354 3.647a.5.5 0 0 0-.707 0L10.5 4.793 7.707 2 8.854.854a.5.5 0 1 0-.707-.707L6.724 1.569 3.793 2.654a2.51 2.51 0 0 0-1.537 1.658l-1.7 5.96a1.345 1.345 0 0 0 1.667 1.674l5.942-1.689A2.51 2.51 0 0 0 9.823 8.73l1.107-2.953 1.423-1.423a.5.5 0 0 0 0-.707M8.886 8.379a1.5 1.5 0 0 1-.994.917l-5.56 1.58 2.909-2.91q.124.035.259.035a1 1 0 1 0-.966-.741l-2.909 2.908 1.592-5.58c.131-.458.476-.83.922-.996l2.734-1.011 3.045 3.045z" />
    ),
    viewBox: { width: 13, height: 12 },
  },

  // Three left-aligned rules of decreasing length — the ordering control on
  // the employment sections. Drawn here rather than reused from `filter`,
  // which is a funnel: sorting and filtering are different promises to the
  // user.
  sort: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="1.5">
        <path d="M3 5h14M3 10h9M3 15h4" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  sparkles: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16.25 20a.83.83 0 0 1-.774-.523l-.704-1.761-1.763-.743a.839.839 0 0 1 .03-1.547l1.74-.66.697-1.743a.84.84 0 0 1 1.548 0l.7 1.75 1.75.701a.839.839 0 0 1 0 1.549l-1.75.7-.7 1.75a.83.83 0 0 1-.774.527m-7.917-2.5a1.67 1.67 0 0 1-1.613-1.177l-1.345-4.206-4.22-1.412A1.693 1.693 0 0 1 1.2 7.479l4.186-1.278 1.41-4.212A1.63 1.63 0 0 1 8.423.833a1.67 1.67 0 0 1 1.598 1.2l1.276 4.179 4.192 1.341a1.702 1.702 0 0 1 0 3.227l-4.2 1.343-1.342 4.2A1.67 1.67 0 0 1 8.333 17.5m.094-14.98L6.833 7.136a.83.83 0 0 1-.546.533L1.686 9.073l4.617 1.598a.83.83 0 0 1 .53.536l1.475 4.608 1.525-4.608a.83.83 0 0 1 .54-.54l4.609-1.474.016-.008-4.625-1.518a.83.83 0 0 1-.543-.551zm8.656 3.313a.83.83 0 0 1-.808-.63l-.298-1.192-1.194-.321a.833.833 0 0 1 .029-1.617l1.166-.27.297-1.172a.833.833 0 0 1 1.617 0l.294 1.182 1.182.295a.833.833 0 0 1 0 1.617l-1.181.296-.296 1.182a.83.83 0 0 1-.808.63" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  spinner: {
    path: (
      <>
        <circle cx="8" cy="8" r="7" stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeOpacity=".25" strokeWidth="2" />
        <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="2" d="M15 8a7 7 0 0 0-7-7" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  split: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M10 20a.833.833 0 0 1-.834-.833V.833a.833.833 0 1 1 1.666 0v18.334c0 .46-.372.833-.833.833m5.588-12.744 1.911 1.91h-4.166a.833.833 0 1 0 0 1.667h4.166l-1.91 1.911a.83.83 0 0 0 0 1.178.833.833 0 0 0 1.178 0l2.744-2.744a1.67 1.67 0 0 0 0-2.356l-2.744-2.744a.832.832 0 1 0-1.179 1.178M4.41 12.744l-1.91-1.91h4.166a.833.833 0 1 0 0-1.667H2.499L4.41 7.256a.832.832 0 1 0-1.178-1.179L.488 8.823A1.66 1.66 0 0 0 0 10c0 .427.163.853.488 1.178l2.744 2.744a.832.832 0 1 0 1.178-1.178" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // Arrow entering a rounded square — "move this into that field". Used by the
  // Introduction's Accept button, which pushes a suggested recap into the
  // statement beside it. The source SVG's full-bleed clipPath is dropped: it
  // covers the whole viewBox, so it clips nothing and only risks an id clash.
  "square-right": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M0 2.5v7A2.503 2.503 0 0 0 2.5 12h7A2.503 2.503 0 0 0 12 9.5v-7A2.503 2.503 0 0 0 9.5 0h-7A2.503 2.503 0 0 0 0 2.5M9.5 1A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7A1.5 1.5 0 0 1 2.5 1zM6.56 3.147a.5.5 0 0 0 0 .707L8.208 5.5 3 5.503a.5.5 0 1 0 0 1L8.207 6.5 6.56 8.146a.5.5 0 1 0 .695.72l.013-.012L9.06 7.06a1.5 1.5 0 0 0 0-2.121L7.267 3.145a.5.5 0 0 0-.707 0" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  // The solid star. `starred` is this drawing locked to brand gold.
  "star-filled": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M1.106 10.334 4.073 12.5l-1.127 3.49A2.65 2.65 0 0 0 3.933 19a2.65 2.65 0 0 0 3.166-.015L10 16.849l2.902 2.133a2.689 2.689 0 0 0 4.152-2.992l-1.126-3.49 2.966-2.166a2.69 2.69 0 0 0-1.583-4.86h-3.644L12.56 2.027a2.689 2.689 0 0 0-5.122 0L6.333 5.474h-3.64a2.69 2.69 0 0 0-1.584 4.86z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  star: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19.864 7.329a2.65 2.65 0 0 0-2.556-1.855h-3.641L12.56 2.027a2.689 2.689 0 0 0-5.122 0L6.333 5.474h-3.64a2.69 2.69 0 0 0-1.584 4.86L4.073 12.5l-1.127 3.49A2.65 2.65 0 0 0 3.933 19a2.65 2.65 0 0 0 3.166-.015L10 16.849l2.902 2.133a2.689 2.689 0 0 0 4.152-2.992l-1.126-3.49 2.966-2.166a2.65 2.65 0 0 0 .97-3.005M17.91 8.988l-3.453 2.524a.83.83 0 0 0-.302.93l1.313 4.058a1.023 1.023 0 0 1-1.58 1.138l-3.395-2.5a.83.83 0 0 0-.987 0l-3.396 2.5A1.023 1.023 0 0 1 4.528 16.5l1.316-4.058a.83.83 0 0 0-.301-.93L2.089 8.988a1.023 1.023 0 0 1 .604-1.848h4.25a.83.83 0 0 0 .793-.578l1.292-4.026a1.022 1.022 0 0 1 1.946 0l1.292 4.026a.83.83 0 0 0 .793.578h4.25a1.022 1.022 0 0 1 .604 1.848z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "sticky-note": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 0H4.167A4.17 4.17 0 0 0 0 4.167v11.666C0 18.133 1.867 20 4.167 20h9.45a4.16 4.16 0 0 0 2.95-1.217l2.216-2.216A4.15 4.15 0 0 0 20 13.617v-9.45C20 1.867 18.133 0 15.833 0M4.167 18.333a2.507 2.507 0 0 1-2.5-2.5V4.167c0-1.375 1.125-2.5 2.5-2.5h11.666c1.375 0 2.5 1.125 2.5 2.5V12.5H15a2.507 2.507 0 0 0-2.5 2.5v3.333zm11.216-.733a2.47 2.47 0 0 1-1.216.667v-3.275c0-.459.375-.834.833-.834h3.275c-.1.459-.333.884-.667 1.217z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  stop: {
    path: (
      <rect width="12" height="12" x="2" y="2" fill="var(--icon-fill, currentColor)" rx="2" />
    ),
    viewBox: { width: 16, height: 16 },
  },

  strikethrough: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5q-1.2-3.3-2.7-9c-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1q.3 3.45.6 5.7c6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9" />
      </g>
    ),
    viewBox: { width: 1024, height: 1024 },
    defaultSize: { width: 24, height: 24 },
  },

  "suggest-edit": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM10 15h4M10 9h4M12 7v4" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  "supplemental-appointment-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 1.667H15V.833a.834.834 0 0 0-1.667 0v.834H6.667V.833A.834.834 0 0 0 5 .833v.834h-.833A4.17 4.17 0 0 0 0 5.833v10A4.17 4.17 0 0 0 4.167 20H7.5a.834.834 0 0 0 0-1.667H4.167a2.503 2.503 0 0 1-2.5-2.5v-7.5h17.5c.46 0 .833-.373.833-.833V5.833a4.17 4.17 0 0 0-4.167-4.166m2.5 5H1.667v-.834c0-1.378 1.121-2.5 2.5-2.5h11.666c1.379 0 2.5 1.122 2.5 2.5zm-2.6 4.066-4.756 4.755A3.31 3.31 0 0 0 10 17.846v1.322c0 .46.373.833.833.833h1.322c.89 0 1.728-.348 2.357-.977l4.755-4.756c.473-.472.733-1.1.733-1.768s-.26-1.296-.732-1.767c-.945-.946-2.591-.946-3.536 0m2.356 2.356-4.756 4.756a1.65 1.65 0 0 1-1.179.488h-.488v-.488c0-.445.173-.863.488-1.178l4.757-4.756a.853.853 0 0 1 1.178 0 .83.83 0 0 1 .244.589.83.83 0 0 1-.244.59M4.167 11.667c0-.46.373-.834.833-.834h5.833a.834.834 0 0 1 0 1.667H5a.834.834 0 0 1-.833-.833m5 3.333c0 .46-.374.833-.834.833H5a.834.834 0 0 1 0-1.666h3.333c.46 0 .834.373.834.833" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  table: {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18" />
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="M3 9h18M3 15h18" />
      </g>
    ),
    viewBox: { width: 24, height: 24 },
  },

  "text-color": {
    path: (
      <g stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 11 8 2.5l3.5 8.5M5.75 8h4.5M3 13.75h10" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Typographic "T" over a paragraph rule — the text-tool glyph. Used for
  // "read this document's extracted text" (the Introduction's OCR button). The
  // source SVG's clipPath was a full-viewBox rect, so it is dropped: it
  // clipped nothing and its id would have to be unique per render.
  text: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M12 7.75V8c0 .275-.225.5-.5.5A.5.5 0 0 1 11 8v-.25a.75.75 0 0 0-.75-.75H9.5v4c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5V7h-.75a.75.75 0 0 0-.75.75V8c0 .275-.225.5-.5.5A.5.5 0 0 1 6 8v-.25C6 6.785 6.785 6 7.75 6h2.5c.965 0 1.75.785 1.75 1.75M6.5 1.5C7.325 1.5 8 2.175 8 3v.5c0 .275.225.5.5.5s.5-.225.5-.5V3A2.5 2.5 0 0 0 6.5.5h-4A2.5 2.5 0 0 0 0 3v.5c0 .275.225.5.5.5s.5-.225.5-.5V3c0-.825.675-1.5 1.5-1.5H4V11c0 .275.225.5.5.5s.5-.225.5-.5V1.5z" />
    ),
    viewBox: { width: 12, height: 12 },
  },

  "time-past": {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M8 0a7.98 7.98 0 0 0-5.333 2.049V.667a.667.667 0 0 0-1.334 0v2a2 2 0 0 0 2 2h2a.667.667 0 0 0 0-1.334h-2a1 1 0 0 1-.066-.014A6.658 6.658 0 1 1 1.333 8 .667.667 0 1 0 0 8a8 8 0 1 0 8-8" />
        <path d="M8 4a.667.667 0 0 0-.667.667V8c0 .177.07.346.196.471l2 2a.667.667 0 0 0 .942-.942L8.667 7.724V4.667A.667.667 0 0 0 8 4" />
      </g>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "today-visits-tab-icon": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M15.833 1.667H15V.833a.834.834 0 0 0-1.667 0v.834H6.667V.833A.834.834 0 0 0 5 .833v.834h-.833A4.17 4.17 0 0 0 0 5.833v10A4.17 4.17 0 0 0 4.167 20h11.666A4.17 4.17 0 0 0 20 15.833v-10a4.17 4.17 0 0 0-4.167-4.166M4.167 3.333h11.666c1.379 0 2.5 1.122 2.5 2.5v.834H1.667v-.834c0-1.378 1.121-2.5 2.5-2.5m11.666 15H4.167a2.503 2.503 0 0 1-2.5-2.5v-7.5h16.666v7.5c0 1.379-1.121 2.5-2.5 2.5m-2.169-5.54c0 .316-.22.582-.471.722l-1.304.725.579 1.578a.739.739 0 0 1-1.146.838l-1.296-1.003-1.297 1.003a.739.739 0 0 1-1.145-.838l.579-1.578-1.304-.725c-.252-.14-.471-.406-.471-.722a.59.59 0 0 1 .609-.563h1.872l.497-1.902a.694.694 0 0 1 .66-.518c.31.006.582.216.66.518l.496 1.902h1.873a.59.59 0 0 1 .61.563" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  trash: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M14 2.667h-2.067A3.34 3.34 0 0 0 8.666 0H7.333a3.34 3.34 0 0 0-3.267 2.667H2A.667.667 0 1 0 2 4h.666v8.667A3.337 3.337 0 0 0 6 16h4a3.337 3.337 0 0 0 3.333-3.333V4H14a.667.667 0 1 0 0-1.333M7.333 1.333h1.333a2 2 0 0 1 1.886 1.334H5.447a2 2 0 0 1 1.886-1.334M12 12.667a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4h8z" />
        <path fill="var(--icon-fill, currentColor)" d="M6.666 12a.666.666 0 0 0 .667-.667v-4a.667.667 0 0 0-1.333 0v4a.667.667 0 0 0 .666.667M9.333 12a.666.666 0 0 0 .667-.667v-4a.667.667 0 1 0-1.334 0v4a.667.667 0 0 0 .667.667" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "triangle-right": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M7.5 14.9V5.592A.833.833 0 0 1 8.925 5l4.65 4.658a.833.833 0 0 1 0 1.175l-4.65 4.659A.834.834 0 0 1 7.5 14.9" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  umbrella: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M19.765 7.958a10.7 10.7 0 0 0-8.931-6.256V.833a.834.834 0 0 0-1.667 0v.87A10.7 10.7 0 0 0 .223 7.958a3.29 3.29 0 0 0 .337 3.068A3.35 3.35 0 0 0 3.334 12.5h5.833v5a.833.833 0 0 1-1.667 0 .833.833 0 0 0-1.666 0 2.5 2.5 0 0 0 5 0v-5h5.819a3.35 3.35 0 0 0 3.325-2.966 3.3 3.3 0 0 0-.213-1.577m-1.718 2.134a1.66 1.66 0 0 1-1.394.741H3.333a1.66 1.66 0 0 1-1.393-.742 1.6 1.6 0 0 1-.167-1.515C2.985 5.538 6.445 3.333 10 3.333a9.01 9.01 0 0 1 8.216 5.243 1.6 1.6 0 0 1-.169 1.516" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  unavailable: {
    path: (
      <path fill="var(--icon-fill, currentColor)" fillRule="evenodd" d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0M3.682 5.096A8 8 0 0 0 10 18c1.849 0 3.549-.63 4.903-1.683zM10 2a7.96 7.96 0 0 0-4.904 1.682l11.221 11.221A7.96 7.96 0 0 0 18 10a8 8 0 0 0-8-8" clipRule="evenodd" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  underline: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6m-312-76c69.4 0 134.6-27.1 183.8-76.2S772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8S442.6 728 512 728" />
      </g>
    ),
    viewBox: { width: 1024, height: 1024 },
    defaultSize: { width: 24, height: 24 },
  },

  undo: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.987 1.338a8.92 8.92 0 0 0-8.915 8.926A8.91 8.91 0 0 0 4.505 17.3l-.837 1.071a.178.178 0 0 0 .14.288l3.728-.017c.116 0 .201-.11.172-.221l-.882-3.623a.179.179 0 0 0-.314-.067l-.909 1.163a7 7 0 0 1-.654-.58 7.1 7.1 0 0 1-2.092-5.05 7.1 7.1 0 0 1 2.092-5.05A7.1 7.1 0 0 1 10 3.125a7.1 7.1 0 0 1 5.05 2.092 7.1 7.1 0 0 1 2.091 5.048 7.11 7.11 0 0 1-2.614 5.522.177.177 0 0 0-.027.248l.88 1.128a.18.18 0 0 0 .254.029 8.91 8.91 0 0 0 3.295-6.927c0-4.935-4.005-8.933-8.942-8.926" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "up-arrow": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="m14.758 8.234-3.583-3.575a1.667 1.667 0 0 0-2.35 0L5.242 8.234a.833.833 0 1 0 1.183 1.175l2.741-2.742v9.167a.833.833 0 0 0 1.667 0V6.667l2.742 2.742a.834.834 0 0 0 1.183-1.175" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "upload-file": {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M9.975 2.768 8.233 1.025A3.48 3.48 0 0 0 5.757 0H3.5A2.5 2.5 0 0 0 1 2.5v7C1 10.879 2.122 12 3.5 12h5c1.379 0 2.5-1.121 2.5-2.5V5.242c0-.935-.364-1.813-1.025-2.474m-.707.707q.239.24.402.525H7.5a.5.5 0 0 1-.5-.5V1.33q.287.163.525.402zM10 9.5c0 .827-.673 1.5-1.5 1.5h-5C2.673 11 2 10.327 2 9.5v-7C2 1.673 2.673 1 3.5 1h2.258A3 3 0 0 1 6 1.011V3.5C6 4.327 6.673 5 7.5 5h2.489a3 3 0 0 1 .011.242zM7.854 7.24a.5.5 0 1 1-.708.707L6.5 7.301V9.5a.5.5 0 0 1-1 0V7.301l-.646.646a.5.5 0 1 1-.708-.707l.808-.807a1.48 1.48 0 0 1 2.093 0z" />
    ),
    viewBox: { width: 11, height: 12 },
    defaultSize: { width: 16, height: 16 },
  },

  upload: {
    path: (
      <>
        <path fill="var(--icon-fill, currentColor)" d="M10.14 8.818a.178.178 0 0 0-.28 0l-2.5 3.163a.178.178 0 0 0 .14.288h1.65v5.411c0 .098.08.179.178.179h1.34a.18.18 0 0 0 .178-.179v-5.408H12.5c.15 0 .232-.172.14-.288z" />
        <path fill="var(--icon-fill, currentColor)" d="M16.683 6.753a7.145 7.145 0 0 0-6.678-4.614 7.14 7.14 0 0 0-6.68 4.611A4.466 4.466 0 0 0 0 11.067a4.463 4.463 0 0 0 4.462 4.465h.895a.18.18 0 0 0 .179-.179v-1.34a.18.18 0 0 0-.179-.178h-.895a2.767 2.767 0 0 1-2.18-4.473 2.8 2.8 0 0 1 1.475-.975l.846-.221.31-.817A5.482 5.482 0 0 1 6.88 4.82a5.4 5.4 0 0 1 3.125-.987c1.127 0 2.207.342 3.124.987a5.5 5.5 0 0 1 1.967 2.529l.308.814.844.224a2.78 2.78 0 0 1 2.056 2.68c0 .74-.288 1.436-.81 1.958a2.75 2.75 0 0 1-1.956.81h-.895a.18.18 0 0 0-.179.179v1.34c0 .097.08.178.179.178h.895a4.465 4.465 0 0 0 1.145-8.78" />
      </>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },

  video: {
    path: (
      <path fill="var(--icon-fill, currentColor)" d="M16.625 4.613 13.721 1.71A5.8 5.8 0 0 0 9.596.001H5.833a4.17 4.17 0 0 0-4.166 4.166v11.666A4.17 4.17 0 0 0 5.833 20h8.334a4.17 4.17 0 0 0 4.166-4.167V8.738a5.8 5.8 0 0 0-1.708-4.125m-1.178 1.179c.262.262.47.561.65.875H12.5a.835.835 0 0 1-.833-.834V2.236c.313.18.612.388.875.65zm1.22 10.041c0 1.379-1.122 2.5-2.5 2.5H5.833a2.503 2.503 0 0 1-2.5-2.5V4.167c0-1.379 1.122-2.5 2.5-2.5h3.763c.137 0 .269.026.404.039v4.127c0 1.379 1.122 2.5 2.5 2.5h4.128c.013.135.039.267.039.405zm-3.021-4.818-1.146.86v-1.043a.834.834 0 0 0-.833-.833H5.833a.834.834 0 0 0-.833.833v5c0 .46.373.834.833.834h5.834c.46 0 .833-.373.833-.834v-1.041l1.146.859A.847.847 0 0 0 15 14.973v-3.281a.846.846 0 0 0-1.354-.677M10.833 15H6.667v-3.333h4.166z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // The thin bare X. `cross` is the same drawing at a heavier weight — 25% of
  // stroke to extent against this one's 20% — so at the same rendered size the
  // two are visibly different, exactly like `publish` / `publish-bold`. Both
  // kept until a designer picks one.
  "x-mark": {
    path: (
      <path stroke="var(--icon-stroke, var(--icon-fill, currentColor))" strokeLinecap="round" strokeWidth="2" d="m5 5 10 10M15 5 5 15" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  // An imaging glyph with no relative in the registry. Pixel-identical to the
  // `assets/icons/xray.svg` nothing ever imported, which Phase 4 deleted in
  // favour of this.
  xray: {
    path: (
      <g fill="var(--icon-fill, currentColor)">
        <path d="M19.167 18.333h-.834V1.667h.834a.833.833 0 1 0 0-1.667H.833a.833.833 0 1 0 0 1.667h.834v16.666H.833a.833.833 0 1 0 0 1.667h18.334a.833.833 0 1 0 0-1.667M3.333 1.667h13.334v16.666H3.333zm11.542 11.377a2.19 2.19 0 0 0-2.042-1.377h-1.999V10h1.667a.833.833 0 1 0 0-1.667h-1.667V6.667h3.334a.833.833 0 1 0 0-1.667h-3.334v-.833a.833.833 0 1 0-1.666 0V5H5.834a.833.833 0 1 0 0 1.667h3.334v1.666H7.5A.833.833 0 1 0 7.5 10h1.667v1.667H7.134a2.175 2.175 0 0 0-2.025 1.37 2.175 2.175 0 0 0 .482 2.398l.5.5c.471.472 1.1.732 1.767.732h4.286c.668 0 1.296-.26 1.768-.732l.48-.48c.643-.643.829-1.568.484-2.41zm-1.662 1.232-.48.48a.84.84 0 0 1-.59.244H7.857a.84.84 0 0 1-.589-.244l-.5-.5a.53.53 0 0 1-.118-.588c.04-.099.172-.332.517-.335h5.659c.33.003.465.241.506.343a.53.53 0 0 1-.121.6z" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
  },
} as const satisfies Record<string, IconDefinition>;

/**
 * Glyphs with a fixed palette of their own — the `functional-*` status set and
 * friends. `fill` / `stroke` are rejected on these by `IconProps`, because
 * they would repaint only part of the drawing. Source: `Icons/svg/color/`.
 */
const COLOR_ICONS = {
  "arrow-left": {
    path: (
      <path stroke="var(--indigo-gray-900, #181311)" strokeLinejoin="round" strokeWidth="2" d="m12 6-4 4 4 4" />
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 12, height: 12 },
  },

  "check-circle": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-gray-50, #f0f0f0)" />
        <path stroke="var(--indigo-gray-600, #6e6d6c)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m3.5 5.5 2 2 3-3" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-brush": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-sky-500, #5ea4c3)" />
        <g clipPath="url(#functional-brush_a)">
          <path fill="var(--indigo-gray-0, #ffffff)" d="M7.75 3h-3.5A1.25 1.25 0 0 0 3 4.25V5.5a1.75 1.75 0 0 0 1.75 1.75h.5v1a.75.75 0 0 0 1.5 0v-1h.5A1.75 1.75 0 0 0 9 5.5V4.25A1.25 1.25 0 0 0 7.75 3M3.5 4.25a.75.75 0 0 1 .75-.75H5.5v.25a.25.25 0 0 0 .5 0V3.5h.5v.75a.25.25 0 0 0 .5 0V3.5h.5v1.25a.25.25 0 0 0 .5 0V3.546a.75.75 0 0 1 .5.704V5.5h-5zm3.75 2.5H6.5a.25.25 0 0 0-.25.25v1.25a.25.25 0 0 1-.5 0V7a.25.25 0 0 0-.25-.25h-.75A1.25 1.25 0 0 1 3.606 6h4.788a1.25 1.25 0 0 1-1.144.75" />
        </g>
        <defs>
          <clipPath id="functional-brush_a">
            <path fill="var(--indigo-gray-0, #ffffff)" d="M3 3h6v6H3z" />
          </clipPath>
        </defs>
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-check-black": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-gray-900, #181311)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.8 7.734 7.36 10.4l3.84-4" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-check-blue-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-sky-500, #5ea4c3)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.8 7.734 7.36 10.4l3.84-4" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-check-green-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-olive-500, #98ae53)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.8 7.734 7.36 10.4l3.84-4" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-check-green": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-olive-50, #f3f6ea)" />
        <path stroke="var(--indigo-olive-600, #809245)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4.8 7.734 7.36 10.4l3.84-4" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-close": {
    path: (
      <>
        <rect width="20" height="20" fill="#f9f9f9" rx="10" />
        <path stroke="var(--indigo-gray-600, #6e6d6c)" strokeLinecap="round" strokeWidth="2" d="m6 6 8 8m0-8-8 8" />
      </>
    ),
    viewBox: { width: 20, height: 20 },
  },

  "functional-failed-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-rose-500, #b4534d)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeWidth="1.5" d="m5.6 5.6 4.8 4.8m-4.8 0 4.8-4.8" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-failed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-rose-50, #f8efee)" />
        <path stroke="var(--indigo-rose-500, #b4534d)" strokeLinecap="round" strokeWidth="1.5" d="m5.6 5.6 4.8 4.8m-4.8 0 4.8-4.8" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-info-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-gray-800, #383736)" />
        <circle cx="8" cy="4.6" r=".9" fill="var(--indigo-gray-0, #ffffff)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeWidth="1.5" d="M8 7.4v4.1" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-language": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-amber-400, #f8a729)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinejoin="round" d="M6 3a.5.5 0 0 1 .433.25l2.598 4.5a.5.5 0 0 1-.433.75H3.402a.5.5 0 0 1-.433-.75l2.598-4.5.037-.055A.5.5 0 0 1 6 3Z" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-missing-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-gray-600, #6e6d6c)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 8h8" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-missing": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-gray-50, #f0f0f0)" />
        <path stroke="var(--indigo-gray-800, #383736)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 8h8" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-partial-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-amber-400, #f8a729)" />
        <g clipPath="url(#functional-partial-reversed_a)">
          <path fill="var(--indigo-gray-0, #ffffff)" d="M4.807 6.163a.33.33 0 0 1-.08-.463c.266-.377.593-.703.97-.97.15-.107.36-.07.463.08.107.15.07.36-.08.463a3.4 3.4 0 0 0-.81.81.33.33 0 0 1-.273.14.35.35 0 0 1-.194-.06zm.466 3.754a.332.332 0 1 0-.543.383q.403.567.97.97a.34.34 0 0 0 .467-.08.33.33 0 0 0-.08-.463 3.3 3.3 0 0 1-.81-.81zM4.667 8c0-.203.016-.407.053-.603a.333.333 0 0 0-.653-.12 4 4 0 0 0 0 1.446c.03.16.17.274.326.274q.03.002.06-.007c.18-.033.3-.207.267-.387A3.3 3.3 0 0 1 4.667 8m6.06 1.917a3.3 3.3 0 0 1-.81.81.332.332 0 0 0 .193.603q.102 0 .193-.06a4 4 0 0 0 .97-.97.33.33 0 0 0-.08-.463.33.33 0 0 0-.463.08zM8.603 11.28c-.196.037-.4.053-.603.053s-.407-.016-.603-.053a.333.333 0 0 0-.12.653 4 4 0 0 0 1.446 0 .333.333 0 0 0-.12-.653m.12-7.213a4 4 0 0 0-1.446 0 .333.333 0 0 0 .06.66q.03.002.06-.007c.196-.037.4-.053.603-.053s.407.016.603.053q.03.006.06.007a.333.333 0 0 0 .06-.66m2.004 2.016c.063.094.166.14.27.14q.1 0 .196-.06a.33.33 0 0 0 .08-.463 4 4 0 0 0-.97-.97.33.33 0 0 0-.463.08c-.107.15-.07.36.08.443.317.244.587.514.813.83zm1.206 1.194a.333.333 0 0 0-.653.12c.037.196.053.4.053.603s-.016.407-.053.603a.333.333 0 0 0 .267.387q.03.006.06.007a.335.335 0 0 0 .326-.274 4 4 0 0 0 0-1.446" />
        </g>
        <defs>
          <clipPath id="functional-partial-reversed_a">
            <path fill="var(--indigo-gray-0, #ffffff)" d="M4 4h8v8H4z" />
          </clipPath>
        </defs>
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-partial": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-amber-50, #fef5e2)" />
        <g clipPath="url(#functional-partial_a)">
          <path fill="var(--indigo-amber-400, #f8a729)" d="M4.807 6.163a.33.33 0 0 1-.08-.463c.266-.377.593-.703.97-.97.15-.107.36-.07.463.08.107.15.07.36-.08.463a3.4 3.4 0 0 0-.81.81.33.33 0 0 1-.273.14.35.35 0 0 1-.194-.06zm.466 3.754a.332.332 0 1 0-.543.383q.403.567.97.97a.34.34 0 0 0 .467-.08.33.33 0 0 0-.08-.463 3.3 3.3 0 0 1-.81-.81zM4.667 8c0-.203.016-.407.053-.603a.333.333 0 0 0-.653-.12 4 4 0 0 0 0 1.446c.03.16.17.274.326.274q.03.002.06-.007c.18-.033.3-.207.267-.387A3.3 3.3 0 0 1 4.667 8m6.06 1.917a3.3 3.3 0 0 1-.81.81.332.332 0 0 0 .193.603q.102 0 .193-.06a4 4 0 0 0 .97-.97.33.33 0 0 0-.08-.463.33.33 0 0 0-.463.08zM8.603 11.28c-.196.037-.4.053-.603.053s-.407-.016-.603-.053a.333.333 0 0 0-.12.653 4 4 0 0 0 1.446 0 .333.333 0 0 0-.12-.653m.12-7.213a4 4 0 0 0-1.446 0 .333.333 0 0 0 .06.66q.03.002.06-.007c.196-.037.4-.053.603-.053s.407.016.603.053q.03.006.06.007a.333.333 0 0 0 .06-.66m2.004 2.016c.063.094.166.14.27.14q.1 0 .196-.06a.33.33 0 0 0 .08-.463 4 4 0 0 0-.97-.97.33.33 0 0 0-.463.08c-.107.15-.07.36.08.443.317.244.587.514.813.83zm1.206 1.194a.333.333 0 0 0-.653.12c.037.196.053.4.053.603s-.016.407-.053.603a.333.333 0 0 0 .267.387q.03.006.06.007a.335.335 0 0 0 .326-.274 4 4 0 0 0 0-1.446" />
        </g>
        <defs>
          <clipPath id="functional-partial_a">
            <path fill="var(--indigo-gray-0, #ffffff)" d="M4 4h8v8H4z" />
          </clipPath>
        </defs>
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-publish": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-olive-500, #98ae53)" />
        <path fill="var(--indigo-gray-0, #ffffff)" d="M7.25 7.75C7.25 8.44 6.69 9 6 9H4.25C3.56 9 3 8.44 3 7.75V6c0-.69.56-1.25 1.25-1.25h.25a.25.25 0 0 1 .25.25.25.25 0 0 1-.25.25h-.25A.75.75 0 0 0 3.5 6v1.75c0 .412.337.75.75.75H6c.412 0 .75-.338.75-.75A.25.25 0 0 1 7 7.5a.25.25 0 0 1 .25.25m1.533-3.278L7.43 3.075a.247.247 0 0 0-.353-.005.25.25 0 0 0-.005.352l1.285 1.325H6.25c-.69 0-1.25.56-1.25 1.25v1.25c0 .138.112.25.25.25a.25.25 0 0 0 .25-.25v-1.25c0-.412.338-.75.75-.75h2.105L7.07 6.572a.249.249 0 0 0 .18.423c.063 0 .13-.025.18-.075l1.35-1.393a.75.75 0 0 0 .003-1.057z" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-published-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-sky-500, #5ea4c3)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 8.333 8 5m0 0 3 3.333M8 5v6" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-published": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-sky-50, #eef6f8)" />
        <path stroke="var(--indigo-sky-400, #72acc8)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 8.333 8 5m0 0 3 3.333M8 5v6" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-question": {
    path: (
      <>
        <rect width="16" height="16" fill="#f9f9f9" rx="8" />
        <path fill="var(--indigo-gray-600, #6e6d6c)" d="M7.226 9.6c0-1.116.228-1.692 1.116-2.4l.36-.288c.42-.324.696-.744.696-1.248 0-.708-.48-1.2-1.296-1.2-.96 0-1.524.624-1.524 1.74H5.246c0-1.74 1.152-2.808 2.868-2.808 1.5 0 2.592.924 2.592 2.208 0 .924-.528 1.62-1.164 2.112l-.396.3c-.516.408-.696.804-.696 1.584zM7.082 12v-1.548h1.524V12z" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-scheduling-party": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-sky-500, #5ea4c3)" />
        <path fill="var(--indigo-gray-0, #ffffff)" d="M7.5 6C8.327 6 9 5.327 9 4.5S8.327 3 7.5 3 6 3.673 6 4.5 6.673 6 7.5 6m0-2.5a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m-.177 1.177A.25.25 0 0 1 7.25 4.5V4a.25.25 0 0 1 .5 0v.397l.177.176a.25.25 0 1 1-.354.354zm.841 2.037a.775.775 0 0 0-1.07.002l-.367.29c-.799-.338-1.368-.908-1.732-1.736l.29-.364A.77.77 0 0 0 5.5 4.37a.77.77 0 0 0-.214-.534s-.463-.602-.471-.61A.77.77 0 0 0 4.268 3a.76.76 0 0 0-.534.214l-.288.251A1.53 1.53 0 0 0 3 4.56C3 6.469 5.532 9 7.44 9c.419 0 .807-.158 1.106-.458l.227-.263a.775.775 0 0 0 0-1.094c-.008-.008-.609-.471-.609-.471m.244 1.224-.228.263a1.03 1.03 0 0 1-.74.299C5.944 8.5 3.5 6.298 3.5 4.56c0-.285.107-.548.287-.729l.288-.251a.27.27 0 0 1 .377-.01s.46.599.468.606a.27.27 0 0 1 0 .387l-.409.512a.25.25 0 0 0-.036.248c.428 1.067 1.17 1.808 2.205 2.203a.25.25 0 0 0 .245-.038s.505-.401.511-.408a.274.274 0 0 1 .388 0c.007.007.605.468.605.468.098.107.094.274-.02.39" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-sparkles": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-amber-400, #f8a729)" />
        <path fill="var(--indigo-gray-0, #ffffff)" d="M7.875 9a.25.25 0 0 1-.232-.157l-.211-.528-.53-.223a.252.252 0 0 1 .01-.464l.521-.198.21-.523a.252.252 0 0 1 .464 0l.21.525.525.21a.252.252 0 0 1 0 .465l-.525.21-.21.525A.25.25 0 0 1 7.875 9M5.5 8.25a.5.5 0 0 1-.484-.353l-.404-1.262-1.265-.424a.508.508 0 0 1 .013-.967l1.255-.384.423-1.263a.49.49 0 0 1 .489-.347.5.5 0 0 1 .48.36l.382 1.253 1.258.403a.51.51 0 0 1 0 .968l-1.26.403-.403 1.26a.5.5 0 0 1-.484.353m.028-4.494L5.05 5.14a.25.25 0 0 1-.164.16l-1.38.421 1.385.48a.25.25 0 0 1 .159.16l.442 1.382.458-1.382a.25.25 0 0 1 .162-.162l1.382-.442.005-.003L6.112 5.3a.25.25 0 0 1-.163-.165zm2.597.994a.25.25 0 0 1-.243-.19l-.089-.357-.358-.096a.25.25 0 0 1 .008-.485l.35-.081.09-.352a.25.25 0 0 1 .484 0l.089.355.354.088a.25.25 0 0 1 0 .485l-.354.09-.089.354a.25.25 0 0 1-.242.189" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-upload-green": {
    path: (
      <>
        <circle cx="6" cy="6" r="6" fill="var(--indigo-olive-500, #98ae53)" />
        <path fill="var(--indigo-gray-0, #ffffff)" d="M6.042 5.646a.054.054 0 0 0-.084 0l-.75.948a.053.053 0 0 0 .042.087h.495v1.623c0 .03.024.054.054.054H6.2c.03 0 .054-.025.054-.054V6.681h.496c.045 0 .07-.051.042-.086z" />
        <path fill="var(--indigo-gray-0, #ffffff)" d="M8.005 5.026a2.144 2.144 0 0 0-4.007 0 1.34 1.34 0 0 0 .34 2.633h.27c.029 0 .053-.024.053-.053v-.402a.054.054 0 0 0-.054-.053H4.34a.83.83 0 0 1-.212-1.635l.254-.066.093-.245a1.645 1.645 0 0 1 .59-.759c.275-.194.6-.296.937-.296a1.62 1.62 0 0 1 1.289.63q.151.196.239.425l.092.244.253.067a.834.834 0 0 1 .374 1.391.82.82 0 0 1-.587.244h-.268a.054.054 0 0 0-.054.053v.402c0 .03.024.053.054.053h.268a1.339 1.339 0 0 0 .344-2.633" />
      </>
    ),
    viewBox: { width: 12, height: 12 },
  },

  "functional-warning-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-amber-300, #f9ba54)" />
        <path stroke="var(--indigo-gray-0, #ffffff)" strokeWidth="2" d="M8 4.242V8.76M8 10.259v2" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  // Warning-triangle "Partial" status icon — exact Figma composite (Portal DS
  // node 11243:50938): white ⚠ triangle (stroke-width 1.5, apex up, centered
  // at 8.4,8.4) on the #F9BA54 amber circle. Drives the N110 "Partial"
  // delivery status.
  "functional-warning-triangle-reversed": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-amber-300, #f9ba54)" />
        <path fill="none" stroke="var(--indigo-gray-0, #ffffff)" strokeLinejoin="round" strokeWidth="1.5" d="M8.399 5.25a.75.75 0 0 1 .65.375l2.077 3.6a.75.75 0 0 1-.649 1.125H6.32a.75.75 0 0 1-.65-1.125l2.078-3.6a.75.75 0 0 1 .65-.375Z" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  "functional-warning": {
    path: (
      <>
        <circle cx="8" cy="8" r="8" fill="var(--indigo-amber-50, #fef5e2)" />
        <path stroke="var(--indigo-amber-400, #f8a729)" strokeWidth="2" d="M8 4.242V8.76M8 10.259v2" />
      </>
    ),
    viewBox: { width: 16, height: 16 },
  },

  // The brand gold star: `star-filled`'s drawing with a fixed fill. The hex
  // has no primitive token inside the amber ramp, and that ramp inverts in the
  // dark theme, so it stays literal rather than drifting darker at night.
  starred: {
    path: (
      <path fill="#fac25f" d="M1.106 10.334 4.073 12.5l-1.127 3.49A2.65 2.65 0 0 0 3.933 19a2.65 2.65 0 0 0 3.166-.015L10 16.849l2.902 2.133a2.689 2.689 0 0 0 4.152-2.992l-1.126-3.49 2.966-2.166a2.69 2.69 0 0 0-1.583-4.86h-3.644L12.56 2.027a2.689 2.689 0 0 0-5.122 0L6.333 5.474h-3.64a2.69 2.69 0 0 0-1.584 4.86z" />
    ),
    viewBox: { width: 20, height: 20 },
  },

  "tab-editing": {
    path: (
      <g>
        <path fill="#000" d="M15.427 5.075a1.813 1.813 0 0 0-2.562 0l-8.132 8.132A2.48 2.48 0 0 0 4 14.975V16a.5.5 0 0 0 .5.5h1.027a2.48 2.48 0 0 0 1.767-.732l8.133-8.133a1.813 1.813 0 0 0 0-2.561m-8.84 9.987c-.282.28-.663.438-1.06.439H5v-.526a1.5 1.5 0 0 1 .44-1.061l6.171-6.172 1.15 1.15zm8.132-8.133-1.253 1.254-1.15-1.148 1.253-1.253a.812.812 0 1 1 1.148 1.15z" />
      </g>
    ),
    viewBox: { width: 20, height: 20 },
    defaultSize: { width: 16, height: 16 },
  },
} as const satisfies Record<string, IconDefinition>;

/**
 * Keyed by the union, not by `string`: that keeps a misspelled name a build
 * error while giving `<Icon>` a uniform `IconDefinition` to read, instead of a
 * 137-member union of literal shapes where `defaultSize` exists on only some.
 */
export const ICON_REGISTRY: Record<IconName, IconDefinition> = {
  ...MONO_ICONS,
  ...COLOR_ICONS,
};

/**
 * The mono names at runtime, for the places where a name arrives as data and
 * the mono/colour split has to be re-established by a guard rather than by the
 * type. See `isMonoIconName`.
 */
export const MONO_ICON_NAMES: ReadonlySet<string> = new Set(
  Object.keys(MONO_ICONS),
);

/** A glyph that honours `fill` / `stroke`. */
export type MonoIconName = keyof typeof MONO_ICONS;

/** A glyph that paints itself, so `fill` / `stroke` are compile errors. */
export type ColorIconName = keyof typeof COLOR_ICONS;

/**
 * Every icon name. `as const satisfies` above is what keeps this a union:
 * annotating either map `Record<string, IconDefinition>` would widen it back to
 * `string` and a misspelled name would type-check.
 */
export type IconName = MonoIconName | ColorIconName;
